[
  {
    "id": 285,
    "uuid": "cea3afdc-880d-4e99-b222-ad6cfefc8384",
    "hitokoto": "Nothing is true, everything is permitted.",
    "type": "c",
    "from": "刺客信条",
    "from_who": null,
    "creator": "suigintou",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948789",
    "length": 41
  },
  {
    "id": 286,
    "uuid": "6b2e6be6-c5cd-4955-b872-f6d592df7d8e",
    "hitokoto": "越是锐利的小刀切完东西后就越容易变钝。",
    "type": "c",
    "from": "东方永夜抄",
    "from_who": null,
    "creator": "5454554a@2980.com",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948789",
    "length": 19
  },
  {
    "id": 287,
    "uuid": "aed578ce-38ee-4279-9576-9ff61b31a392",
    "hitokoto": "就算一次也好，我想在这颗星球上尽情奔跑。",
    "type": "c",
    "from": "Eden",
    "from_who": null,
    "creator": "vinkey",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948789",
    "length": 20
  },
  {
    "id": 288,
    "uuid": "0ae68f88-4b68-4642-a790-8696c8705116",
    "hitokoto": "承君此诺，必守一生。",
    "type": "c",
    "from": "仙剑奇侠传四",
    "from_who": null,
    "creator": "锦重",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948790",
    "length": 10
  },
  {
    "id": 289,
    "uuid": "096fb8e6-1dba-4697-8c53-85087a1c2431",
    "hitokoto": "少女祈祷中……",
    "type": "c",
    "from": "东方project",
    "from_who": null,
    "creator": "qqa623582347",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948790",
    "length": 7
  },
  {
    "id": 290,
    "uuid": "71a50cf7-b07e-4b0e-8ffb-196b92406e4e",
    "hitokoto": "只要你还记得我，我就会一直在你的身边。",
    "type": "c",
    "from": "符文工房",
    "from_who": null,
    "creator": "摇篮の月",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948790",
    "length": 19
  },
  {
    "id": 291,
    "uuid": "81d955dd-30dc-47cb-a1a4-df354414a879",
    "hitokoto": "这一路上有你的陪伴，我不再孤单。",
    "type": "c",
    "from": "幻想水浒传",
    "from_who": null,
    "creator": "隐之鱼",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948790",
    "length": 16
  },
  {
    "id": 292,
    "uuid": "50da675b-8ee8-4078-bc45-34d5815fdd03",
    "hitokoto": "这是眼泪吗？原来眼泪是这么的温暖，我一直以为，哀伤的东西都是冰冷的。",
    "type": "c",
    "from": "风色幻想",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948791",
    "length": 34
  },
  {
    "id": 293,
    "uuid": "bfd21772-b0eb-4bbc-b2d8-12a0429925d6",
    "hitokoto": "如果我会变成恶魔，那就随他吧。我会接受放逐，一切只为了保护她。",
    "type": "c",
    "from": "鬼泣",
    "from_who": null,
    "creator": "银炎",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948792",
    "length": 31
  },
  {
    "id": 294,
    "uuid": "838219db-13f7-49c0-93c4-e52f87fa0b05",
    "hitokoto": "无论发生什么，都请不要后悔与我的相遇……",
    "type": "c",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "dah",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948792",
    "length": 20
  },
  {
    "id": 295,
    "uuid": "bf4a2487-bee4-43fb-bd1d-da92205976a5",
    "hitokoto": "生尽欢，死无憾。",
    "type": "c",
    "from": "仙剑4",
    "from_who": null,
    "creator": "_SCarLet",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948792",
    "length": 8
  },
  {
    "id": 296,
    "uuid": "db11648d-0baa-4222-8f29-2323c19e39a6",
    "hitokoto": "我决定以人类的一个方法来感激你，我打算以身相许！",
    "type": "c",
    "from": "仙剑奇侠传",
    "from_who": null,
    "creator": "赵吟风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948793",
    "length": 24
  },
  {
    "id": 297,
    "uuid": "8e4cb05d-2fb7-40f4-ad83-307b580d7f00",
    "hitokoto": "从一开始，我就不那么喜欢你。",
    "type": "c",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "隐之鱼",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948793",
    "length": 14
  },
  {
    "id": 298,
    "uuid": "b844bbc8-f866-45c3-9a6f-8a48026cf6e5",
    "hitokoto": "谎言不一定是谎言，被发现的谎言，才算是谎言。",
    "type": "c",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "坏坏的微笑",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948793",
    "length": 22
  },
  {
    "id": 299,
    "uuid": "4cc2156b-f402-4c95-a9a4-d19aa24c641b",
    "hitokoto": "要超越过去与悲伤，用坚强和笑容去开拓明天。",
    "type": "c",
    "from": "伊苏",
    "from_who": null,
    "creator": "SD影",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948794",
    "length": 21
  },
  {
    "id": 300,
    "uuid": "ad663796-f067-4b17-809b-18b2a6cb9855",
    "hitokoto": "人总是会变的，不要害怕改变哦。",
    "type": "c",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "幻、天使",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948794",
    "length": 15
  },
  {
    "id": 302,
    "uuid": "e635a397-4933-46c5-9360-f85ae41131a3",
    "hitokoto": "刁蛮少女贵千金，比武招亲动芳心。盼能与君长相依，结伴江湖侠侣行。",
    "type": "c",
    "from": "仙剑奇侠传",
    "from_who": null,
    "creator": "赵吟风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948796",
    "length": 32
  },
  {
    "id": 303,
    "uuid": "3c2b4d32-5f15-4b9b-8d4f-a9b9a6b730a0",
    "hitokoto": "工程穷三代，考古毁一生。",
    "type": "c",
    "from": "魔兽世界",
    "from_who": null,
    "creator": "红叶乘风我愿",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948797",
    "length": 12
  },
  {
    "id": 304,
    "uuid": "99a353a2-33d4-4ae2-b319-1a3d631b833f",
    "hitokoto": "愿风指引着你的道路，愿你的刀刃永远锋利。",
    "type": "c",
    "from": "魔兽世界",
    "from_who": null,
    "creator": "诺克提斯",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948798",
    "length": 20
  },
  {
    "id": 305,
    "uuid": "1cf89f13-7fd1-45fe-90c7-cc451425070a",
    "hitokoto": "虽有遗憾，并无后悔。",
    "type": "c",
    "from": "古剑奇谭",
    "from_who": null,
    "creator": "_SCarLet",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948802",
    "length": 10
  },
  {
    "id": 306,
    "uuid": "ce4c040d-c11e-49fe-a432-e8935d8ed9d3",
    "hitokoto": "魔非魔，道非道，善恶在人心。欲非欲，情非情，姻缘由天定。",
    "type": "c",
    "from": "仙剑奇侠传",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948805",
    "length": 28
  },
  {
    "id": 307,
    "uuid": "41e3a9ae-6411-448c-87fd-ed11ba750742",
    "hitokoto": "人与人在偶然之中创造相遇与别离。",
    "type": "c",
    "from": "银河和声",
    "from_who": null,
    "creator": "草莓的味道",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948806",
    "length": 16
  },
  {
    "id": 308,
    "uuid": "3745a608-92f1-44fc-a413-56b2741b5e0e",
    "hitokoto": "一年、两年、三年……十年、百年、千年……即使用永恒的时间来等待，我也想再见你一面。",
    "type": "c",
    "from": "幻想三国志",
    "from_who": null,
    "creator": "小刺鸟",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948827",
    "length": 41
  },
  {
    "id": 309,
    "uuid": "a4c05e44-d5d7-43ad-8887-41ad57bade72",
    "hitokoto": "少年心意，一如明月松间的青石流水，那些年里看到了，却不懂。",
    "type": "c",
    "from": "诛仙二",
    "from_who": null,
    "creator": "以风之名",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468948842",
    "length": 29
  },
  {
    "id": 448,
    "uuid": "20ab5cc4-64b4-4be4-a35a-a4b6977d26ae",
    "hitokoto": "人是只要活在世上，就是必须背负某种罪孽的存在，正是这样，人只要活著就总会面对[墙壁]。重要的是要有跨越墙壁的意志。",
    "type": "c",
    "from": "零之轨迹",
    "from_who": "罗伊德",
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949639",
    "length": 57
  },
  {
    "id": 530,
    "uuid": "e0f71026-c3c5-4101-a796-19239f22ddc7",
    "hitokoto": "绚烂如繁樱，瞬息绽放后凋落。 花以香为证，曾美至惊心动魄。",
    "type": "c",
    "from": "薄樱鬼",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550771",
    "length": 29
  },
  {
    "id": 618,
    "uuid": "cd2fc85c-9c50-4f29-8680-7bb2cf77d91d",
    "hitokoto": "「あたいってば最強ね！」（本小姐最強）",
    "type": "c",
    "from": "琪露诺",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475083577",
    "length": 19
  },
  {
    "id": 630,
    "uuid": "c1021951-e761-417c-9100-36d4deb75001",
    "hitokoto": "我不承认需要有人牺牲的魔法，而且人与人的思念，可以超越魔法。",
    "type": "c",
    "from": "芳乃樱",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475083942",
    "length": 30
  },
  {
    "id": 631,
    "uuid": "f890c95d-4254-4c11-9454-e4a6e173ccec",
    "hitokoto": "能够实现愿望的樱花树啊，为什么不能满足这些孩子们如此真诚的要求呢？",
    "type": "c",
    "from": "芳乃樱",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475083989",
    "length": 33
  },
  {
    "id": 632,
    "uuid": "943aaa54-3084-4840-aebf-6973ceae87fd",
    "hitokoto": "我就是小偷，专门来偷走哥哥的心",
    "type": "c",
    "from": "芳乃樱",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475083889",
    "length": 15
  },
  {
    "id": 642,
    "uuid": "e09c0184-94eb-4fe2-ab19-1e3212a4641c",
    "hitokoto": "怎么样，士道君，四糸乃很酷吧，四糸乃很酷吧",
    "type": "c",
    "from": "四糸乃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475080221",
    "length": 21
  },
  {
    "id": 661,
    "uuid": "123dd35a-abb3-40b9-9e8a-c3305758ba26",
    "hitokoto": "那随风飘荡的蒲公英种子，会在什么时候决定自己的命运呢？",
    "type": "c",
    "from": "沙耶之歌",
    "from_who": null,
    "creator": "zchimou",
    "creator_uid": 23,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475592060",
    "length": 27
  },
  {
    "id": 662,
    "uuid": "5db3f43b-ed95-4752-bd75-83d64c260c08",
    "hitokoto": "有了她灿烂的笑脸,有了活下去面对每一天的勇气。",
    "type": "c",
    "from": "沙耶之歌",
    "from_who": null,
    "creator": "zchimou",
    "creator_uid": 23,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475592045",
    "length": 23
  },
  {
    "id": 663,
    "uuid": "ba4bc57b-9563-4204-9ca4-028c7510eace",
    "hitokoto": "最后呢，在这片沙漠之中，至少我能知道还会有一个，珍爱这朵花儿的人。有一个人就足够了。",
    "type": "c",
    "from": "沙耶之歌",
    "from_who": null,
    "creator": "zchimou",
    "creator_uid": 23,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475592030",
    "length": 42
  },
  {
    "id": 664,
    "uuid": "cfbffab6-a58e-43d2-a284-233e0fe7eaa1",
    "hitokoto": "纯氧对生物有害，毫无保留的真相，只会把人的精神击溃。一比五的氧与氮，才是可供呼吸的空气。同样，呼吸著以戏言稀释的少量真实，人才能维持健全的心。",
    "type": "c",
    "from": "沙耶之歌",
    "from_who": null,
    "creator": "zchimou",
    "creator_uid": 23,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475592007",
    "length": 71
  },
  {
    "id": 681,
    "uuid": "53d2f4d5-13a3-4dcd-b120-89752b7dd814",
    "hitokoto": "关门，放狗！",
    "type": "c",
    "from": "训犬者洛克希",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361405",
    "length": 6
  },
  {
    "id": 682,
    "uuid": "9cc9d04a-33cd-4398-bdf5-5450f3556b67",
    "hitokoto": "我战斗到了最后一刻！",
    "type": "c",
    "from": "战争守卫沙尔图拉",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361427",
    "length": 10
  },
  {
    "id": 683,
    "uuid": "03121a11-cdd6-4a1c-a91a-2f4f619cb8c7",
    "hitokoto": "正在上课！",
    "type": "c",
    "from": "阴郁院长加丁",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361450",
    "length": 5
  },
  {
    "id": 684,
    "uuid": "3e2840e0-ff5f-496c-90d0-5323abc1e6ba",
    "hitokoto": "你的死亡让我的掉败更加沉重！",
    "type": "c",
    "from": "堕降的瓦拉斯塔兹",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361469",
    "length": 14
  },
  {
    "id": 685,
    "uuid": "e98947bd-f5d6-489f-9552-d1de45a8e682",
    "hitokoto": "生命本身毫无意义，只有死亡才能让你邃晓人性的真谛！",
    "type": "c",
    "from": "大领主莫格莱尼",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361490",
    "length": 25
  },
  {
    "id": 686,
    "uuid": "e43632fb-dfc5-4d3f-b014-52c76617c022",
    "hitokoto": "这就是好奇的代价！",
    "type": "c",
    "from": "艾索雷葛斯",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361507",
    "length": 9
  },
  {
    "id": 687,
    "uuid": "8c9193f6-020b-4811-bc9d-41aac408c248",
    "hitokoto": "为你而战，我的女士！",
    "type": "c",
    "from": "血色指挥官莫格莱尼",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361531",
    "length": 10
  },
  {
    "id": 688,
    "uuid": "f6566a28-021a-4011-901a-d41e9a6ec615",
    "hitokoto": "尘归尘，土归土！",
    "type": "c",
    "from": "管理者埃克索图斯",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361554",
    "length": 8
  },
  {
    "id": 689,
    "uuid": "e74a8578-88f8-424e-9b4f-aedd1e248271",
    "hitokoto": "要邃晓你的处境，凡人！",
    "type": "c",
    "from": "奥妮克希亚",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361572",
    "length": 11
  },
  {
    "id": 690,
    "uuid": "20ffd375-c8b7-4fc5-ad3f-0acf478b96cd",
    "hitokoto": "我……败……了……",
    "type": "c",
    "from": "无疤者奥斯里安",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361384",
    "length": 9
  },
  {
    "id": 691,
    "uuid": "b2e69606-69cf-403b-8450-5705eafc2a83",
    "hitokoto": "“沙漠，扬起你的沙砾，遮蔽太阳的光芒吧！！”",
    "type": "c",
    "from": "无疤者奥斯里安",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476360934",
    "length": 22
  },
  {
    "id": 692,
    "uuid": "a336a09d-32da-4aaf-a915-c542780a7c1d",
    "hitokoto": "我们是圣骑士，不能让复仇的情绪占据我们的意识。",
    "type": "c",
    "from": "光明使者乌瑟尔",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476360961",
    "length": 23
  },
  {
    "id": 693,
    "uuid": "254deac6-1144-48d3-b0f8-a6295de4ffb5",
    "hitokoto": "没人生来杰出。",
    "type": "c",
    "from": "奥格瑞姆.毁灭之锤",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476360991",
    "length": 7
  },
  {
    "id": 694,
    "uuid": "846f42f8-c6a5-47e1-b2d1-5bb37feaa0a2",
    "hitokoto": "颤抖吧,凡人！",
    "type": "c",
    "from": "阿克蒙德",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361019",
    "length": 7
  },
  {
    "id": 695,
    "uuid": "829f05b7-651e-47b1-8b35-63c099583618",
    "hitokoto": "退后，你们这些无知的家伙！你不会就这样死的，我的国王！",
    "type": "c",
    "from": "克尔苏加德",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361041",
    "length": 27
  },
  {
    "id": 696,
    "uuid": "67a7f547-b9dc-4a3f-b325-899b8cd4d86d",
    "hitokoto": "最后，我终于解放了我自己……",
    "type": "c",
    "from": "格罗姆.地狱咆哮",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361065",
    "length": 14
  },
  {
    "id": 697,
    "uuid": "aefc2293-070c-4080-8132-55fe247b66ed",
    "hitokoto": "叛徒？事实上，我才是被背叛的人！",
    "type": "c",
    "from": "伊利丹.怒风",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361088",
    "length": 16
  },
  {
    "id": 698,
    "uuid": "be62b743-eed6-4667-80e3-76ebc6c356a7",
    "hitokoto": "种族不代表荣耀，我见过最高尚的兽人，也见过最卑劣的人类。",
    "type": "c",
    "from": "提里奥.弗丁",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361112",
    "length": 28
  },
  {
    "id": 699,
    "uuid": "c4ca48e7-1084-4094-8dad-8e2fba2045cf",
    "hitokoto": "Now,we are one！！",
    "type": "c",
    "from": "阿尔萨斯\u0026巫妖王耐奥祖",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361136",
    "length": 16
  },
  {
    "id": 700,
    "uuid": "904dd817-9e10-47da-b4cc-c6f41a9413df",
    "hitokoto": "这个世界已经不再需要我这个守护者了，大地的创伤，会由它自己慢慢的回复，而各个生存在这里的种族的未来，就只有靠他们自己的努力了。",
    "type": "c",
    "from": "麦迪文",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476361160",
    "length": 63
  },
  {
    "id": 722,
    "uuid": "606c8d92-aba1-4f70-ae4d-483cc9bd2c93",
    "hitokoto": "生生生生暗生始，死死死死冥死终。",
    "type": "c",
    "from": "东方永夜抄",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 752,
    "uuid": "bc1f4c9f-09a3-42ed-b5d1-890d17a143f9",
    "hitokoto": "少女祈祷中…",
    "type": "c",
    "from": "东方project",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 6
  },
  {
    "id": 775,
    "uuid": "3cd7d64c-7527-4b9c-90e1-8e717fd4af4f",
    "hitokoto": "人能够在心里郁积那么多的事情，而他们又会忘记那么多的事情，真是不可思议…",
    "type": "c",
    "from": "最终幻想",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 36
  },
  {
    "id": 780,
    "uuid": "33ba4fc1-12ed-43bb-875e-60e0cf4c9082",
    "hitokoto": "我是最强的！",
    "type": "c",
    "from": "东方Project",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 6
  },
  {
    "id": 798,
    "uuid": "e17412b6-ed31-4ab8-a6e6-ef645e95cb59",
    "hitokoto": "到底该怎么做，你才会重新喜欢我呢？",
    "type": "c",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 818,
    "uuid": "85b1fa8b-83ba-411a-90a1-ae5c512c13ed",
    "hitokoto": "一年、两年、三年…十年、百年、千年…即使用永恒的时间来等待，我也想再见你一面。",
    "type": "c",
    "from": "幻想三国志",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 39
  },
  {
    "id": 843,
    "uuid": "3b9be5e0-b47d-47db-822b-727561b8d818",
    "hitokoto": "如果我贏了，你就是我的人了",
    "type": "c",
    "from": "零之轨迹",
    "from_who": "罗伊德",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 856,
    "uuid": "25e54ec6-e47d-4505-81a3-3e3fbfd69629",
    "hitokoto": "我的黑衣又该如何将你的星空包裹。",
    "type": "c",
    "from": "东方同人志",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 862,
    "uuid": "12942eba-d818-4865-9ff1-f0244364e0f9",
    "hitokoto": "我就这样从《圣经》偷出些断章残句，来掩饰我的赤裸裸的罪行。外表上装做圣徒，暗地里是八卦心肠。",
    "type": "c",
    "from": "碧之轨迹",
    "from_who": "瓦吉",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 46
  },
  {
    "id": 934,
    "uuid": "61739833-ca8f-4bb6-ba00-de2b167932f5",
    "hitokoto": "让留下的人，笑着活下去",
    "type": "c",
    "from": "narcissu",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 1048,
    "uuid": "469f488e-a818-4887-b8de-5e0dcdedce38",
    "hitokoto": "或许人和人之间的缘分，都是注定的。",
    "type": "c",
    "from": "仙剑奇侠传四",
    "from_who": "柳梦璃",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1063,
    "uuid": "a7050849-bb99-4faa-a90c-576e1182b66b",
    "hitokoto": "即使你改变了过程，也改不了结果。",
    "type": "c",
    "from": "仙剑奇侠传4",
    "from_who": "上软",
    "creator": "2021823134",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 16
  },
  {
    "id": 1118,
    "uuid": "9ab38f1c-de48-43b3-8dc1-fe14d39b22d4",
    "hitokoto": "我宁可一开始就不认识那个人，也好过相识以后却要生死离别。",
    "type": "c",
    "from": "仙剑4",
    "from_who": "韩菱纱",
    "creator": "1015964489",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 28
  },
  {
    "id": 1153,
    "uuid": "33dc988d-9e42-4f1e-9cd5-bce0eb03fe5b",
    "hitokoto": "十步杀一人，千里不留行。",
    "type": "c",
    "from": "李白",
    "from_who": null,
    "creator": "雨绝",
    "creator_uid": 273,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1490448489",
    "length": 12
  },
  {
    "id": 1245,
    "uuid": "108e9b23-ed80-4622-9574-f0c406e77a34",
    "hitokoto": "电脑高手,哈哈哈哈哈,你这嘴里蹦的都是几几年的形容词啊",
    "type": "c",
    "from": "三色绘恋",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1506085174",
    "length": 27
  },
  {
    "id": 1246,
    "uuid": "ca7ced20-e362-4fdb-be24-a8e21c31ec67",
    "hitokoto": "无论是钱，是名，还是其他的什么东西——只要他觉得有，他就会去做。哪怕是。。交易",
    "type": "c",
    "from": "三色绘恋",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1506086053",
    "length": 39
  },
  {
    "id": 1247,
    "uuid": "e4724c8f-b365-4521-b799-d6504405bc41",
    "hitokoto": "那些每天骂公司骂社会骂国家的大人，不还是得为了那么点钱起早贪黑地蹬着自行车上班么。",
    "type": "c",
    "from": "三色绘恋",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1506086238",
    "length": 41
  },
  {
    "id": 1248,
    "uuid": "8539f824-43b8-4a57-9ac1-6b5b1a2da226",
    "hitokoto": "那为什么我高一的时候整个年级组里就只见得着老头儿和老太太呢，真是匪夷所思。",
    "type": "c",
    "from": "三色绘恋",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1506084623",
    "length": 37
  },
  {
    "id": 1257,
    "uuid": "c6bec054-b84b-4b7a-9f62-9fa74f5d184e",
    "hitokoto": "坚决不要相信任何班主任说过的 马上放学 ，果然是这个世界上的某一句真理。",
    "type": "c",
    "from": "三色绘恋",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1506157792",
    "length": 36
  },
  {
    "id": 1282,
    "uuid": "aff10dd7-04ea-4e71-a330-4ab37ca5298a",
    "hitokoto": "知识不求人。",
    "type": "c",
    "from": "最终幻想XIV",
    "from_who": null,
    "creator": "LegendHeaven",
    "creator_uid": 688,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509701038",
    "length": 6
  },
  {
    "id": 1284,
    "uuid": "510ec642-77ce-450b-88a4-3d240c9b6f21",
    "hitokoto": "猎人永不孤单。",
    "type": "c",
    "from": "Bloodborne",
    "from_who": null,
    "creator": "LegendHeaven",
    "creator_uid": 688,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509707993",
    "length": 7
  },
  {
    "id": 1300,
    "uuid": "495075f7-3ddd-4755-8cac-39e6e791f309",
    "hitokoto": "光明，制造瞎子",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "后羿",
    "creator": "9527",
    "creator_uid": 772,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1511615972",
    "length": 7
  },
  {
    "id": 1334,
    "uuid": "1eb02f5b-21dc-4fb6-a8e5-673ecbce3a53",
    "hitokoto": "未来不是被给予的，而是自己争取的",
    "type": "c",
    "from": "尼尔：机械纪元",
    "from_who": null,
    "creator": "Aaron",
    "creator_uid": 956,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513574052",
    "length": 16
  },
  {
    "id": 1359,
    "uuid": "791c87a1-f7ad-4ebe-b0c5-84f0ebebe005",
    "hitokoto": "万物皆虚，万事皆允",
    "type": "c",
    "from": "刺客信条",
    "from_who": null,
    "creator": "鼇鬖",
    "creator_uid": 1070,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516437503",
    "length": 9
  },
  {
    "id": 3583,
    "uuid": "087547b0-f2cd-40f4-8cb8-2176b9ac55b9",
    "hitokoto": "所有的梦境都是另一个现实，永远不要忘记。",
    "type": "c",
    "from": "漆黑的魅影",
    "from_who": null,
    "creator": "MXLBS",
    "creator_uid": 1288,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521289329",
    "length": 20
  },
  {
    "id": 3649,
    "uuid": "55ede87a-29e5-4347-b225-3d4c2958e11a",
    "hitokoto": "时螶以爱吻我，我当回报以歌。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528034712",
    "length": 14
  },
  {
    "id": 3650,
    "uuid": "a0fdfddd-3335-4695-a282-5780114564d9",
    "hitokoto": "The cake is a lie.",
    "type": "c",
    "from": "Portal",
    "from_who": null,
    "creator": "OwenOwl",
    "creator_uid": 1616,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528551157",
    "length": 18
  },
  {
    "id": 3653,
    "uuid": "a10d421d-4f82-4860-81f0-bf990cb769d2",
    "hitokoto": "以我全部的生命和力量，保卫人权大宪章，并将其延伸至银河所有知觉生命的正当权利。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528508778",
    "length": 39
  },
  {
    "id": 3656,
    "uuid": "fb8425cd-0338-47f8-b0be-51c2382b0bc4",
    "hitokoto": "I solemnly swear, to devote my life and abilities, in defense of the United Nations of Earth, to defend the constitution of man, and to further the universal rights of all sentient life, from the depths of the Pacific, to the edge of the galaxy, for as lo",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528186927",
    "length": 255
  },
  {
    "id": 3657,
    "uuid": "4660d02e-e841-4238-be2a-6196f1a39ffd",
    "hitokoto": "在那里，悖论相互交织成结并最终凝结成一个意识体，一个处于时间之外的欲望与意志的联结。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528187014",
    "length": 42
  },
  {
    "id": 3658,
    "uuid": "4c22a682-846f-4cb5-a5b9-71bce51965bd",
    "hitokoto": "如果我们这么做了，某些事情将会发生。我们必须这么做，这是科学的探索。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528034767",
    "length": 34
  },
  {
    "id": 3662,
    "uuid": "62995980-3442-4097-bccd-cd0ad54c92ca",
    "hitokoto": "为了明天和下个明天.怀抱着籍由互相弥补而获得,无可取代的平静.",
    "type": "c",
    "from": "KARAKARA",
    "from_who": null,
    "creator": "神子少女A",
    "creator_uid": 1660,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529314128",
    "length": 31
  },
  {
    "id": 3664,
    "uuid": "11c796ea-04d5-4c88-b683-72255ec5d77a",
    "hitokoto": "身为蝼蚁的你，真的很努力呢。",
    "type": "c",
    "from": "克里斯",
    "from_who": null,
    "creator": "黄昏的境界线",
    "creator_uid": 1672,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529712908",
    "length": 14
  },
  {
    "id": 3742,
    "uuid": "6b8e0a1f-7d9e-451a-a424-2007831a2e71",
    "hitokoto": "我被囚禁了一万年，又被逐出了自己的故乡，现在你们竟敢闯入我的领地，真是自寻死路……你们这是自寻死路！",
    "type": "c",
    "from": "魔兽世界 伊莉丹",
    "from_who": null,
    "creator": "althezsh",
    "creator_uid": 185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532150095",
    "length": 50
  },
  {
    "id": 3743,
    "uuid": "66b80467-0539-4ee3-bd5d-470e7300dafb",
    "hitokoto": "狂战似魔，深谋如鬼",
    "type": "c",
    "from": "三国杀 神司马懿",
    "from_who": null,
    "creator": "althezsh",
    "creator_uid": 185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532149691",
    "length": 9
  },
  {
    "id": 3744,
    "uuid": "41c5cc49-c7ab-45c5-9b16-30f07992b94a",
    "hitokoto": "韬光养晦，静待时机",
    "type": "c",
    "from": "三国杀 神司马懿",
    "from_who": null,
    "creator": "althezsh",
    "creator_uid": 185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532149655",
    "length": 9
  },
  {
    "id": 3775,
    "uuid": "c36841c6-7725-40c1-bea8-5c52344be924",
    "hitokoto": "以剑与火之力，异端之地将燃，以异端之烬，银河将得昌盛。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533048473",
    "length": 27
  },
  {
    "id": 3776,
    "uuid": "4463064f-3620-4dac-bd67-712f889899d3",
    "hitokoto": "当时间悖论开始相互纠缠之时，一个难以形容的意识会渐渐苏醒，它渴望着，索求着。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533051518",
    "length": 38
  },
  {
    "id": 3794,
    "uuid": "7407f626-a525-4f77-bf0d-8d7fe9d9ee49",
    "hitokoto": "时间定然是不能双向流动的。缠绕着宇宙的巨蛇，用它那比我们母星还大的双眼暗中窥视，这一切也纯属无稽之谈。然而，曾经的无稽之谈现已一一兑现。",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533051473",
    "length": 68
  },
  {
    "id": 3797,
    "uuid": "6f1ecc4f-9cec-4cff-9c90-f5c592ec6d25",
    "hitokoto": "继续战斗！为了子子孙孙，你们不能放弃！别让我们的牺牲付诸东流！我们……啊啊啊啊啊啊啊——【信号丢失】",
    "type": "c",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533048932",
    "length": 50
  },
  {
    "id": 3804,
    "uuid": "091dc64a-e039-44ed-84ed-282b462ce0c5",
    "hitokoto": "My life for aiur!",
    "type": "c",
    "from": "星际争霸2",
    "from_who": null,
    "creator": "haoduor",
    "creator_uid": 1545,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533302253",
    "length": 17
  },
  {
    "id": 3816,
    "uuid": "3e211013-2aaf-4a2e-8119-b6bdb76566ab",
    "hitokoto": "阁下是，人类？",
    "type": "c",
    "from": "东方妖妖梦",
    "from_who": null,
    "creator": "Hatate",
    "creator_uid": 1939,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534934019",
    "length": 7
  },
  {
    "id": 3825,
    "uuid": "1ba93ac9-7c57-4e42-8c32-474ba31d6ea1",
    "hitokoto": "咖啡哪怕是一瞬间被置于真空当中，就会因为过低的气压导致瞬间的沸腾，之后被夺走蒸发热的水在沸腾的瞬间将冰冻。",
    "type": "c",
    "from": "大空魔術",
    "from_who": null,
    "creator": "Hatate",
    "creator_uid": 1939,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535199769",
    "length": 53
  },
  {
    "id": 3834,
    "uuid": "c600a0c4-b59e-4721-982c-21a2da09ad6f",
    "hitokoto": "不计代价，小子，活下去。",
    "type": "c",
    "from": "gta5麦克",
    "from_who": null,
    "creator": "棠棣",
    "creator_uid": 2016,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535954972",
    "length": 12
  },
  {
    "id": 3835,
    "uuid": "986fce21-8a83-4c80-9bb4-6de689fcfb82",
    "hitokoto": "虽然爱情主要取决于精神层面的东西，但是恋情却在相貌，气味等感官层面占的比例比较大。爱和恋并存，这才是所谓的恋爱啊",
    "type": "c",
    "from": "近月少女的礼仪",
    "from_who": null,
    "creator": "咸鱼咸鱼咸",
    "creator_uid": 2001,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535706223",
    "length": 56
  },
  {
    "id": 3862,
    "uuid": "b67961ac-d89a-4e71-866f-95ca07811605",
    "hitokoto": "萤火之光看起来比平常要更耀眼是错觉吗？今宵会成为永夜的吧。",
    "type": "c",
    "from": "东方永夜抄",
    "from_who": null,
    "creator": "Hatate",
    "creator_uid": 1939,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534775032",
    "length": 29
  },
  {
    "id": 3863,
    "uuid": "3780608f-b216-4fe4-a0b7-7cab4b755850",
    "hitokoto": "地上的光催我妒意，吹拂的风催我妒意。",
    "type": "c",
    "from": "东方地灵殿",
    "from_who": null,
    "creator": "Hatate",
    "creator_uid": 1939,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535033466",
    "length": 18
  },
  {
    "id": 3879,
    "uuid": "4f73ab34-d7cf-4eb0-bad5-afdb5e3adc10",
    "hitokoto": "当老天都不肯放过你的时候,不管怎么努力也都是徒劳......你说呢?",
    "type": "c",
    "from": "赤印Plus 不存在的圣诞节",
    "from_who": null,
    "creator": "神子少女A",
    "creator_uid": 1660,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537041231",
    "length": 34
  },
  {
    "id": 3925,
    "uuid": "b275658b-04f4-4c81-90e0-e415c0af6541",
    "hitokoto": "我为打破你周遭的囚墙而来，览尽世界，为你沉沦。",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537953734",
    "length": 23
  },
  {
    "id": 3926,
    "uuid": "d6d61759-4db6-41ce-a8a1-3d87ad9d98b8",
    "hitokoto": "沉默——真正猎手的选择。",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537955681",
    "length": 12
  },
  {
    "id": 3929,
    "uuid": "c6feddd6-22ac-41a0-be62-00c4789683bb",
    "hitokoto": "回声：寻觅归乡之路，一次一颗子弹",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537956272",
    "length": 16
  },
  {
    "id": 3970,
    "uuid": "351be344-4d33-4a7a-91e1-72ac8538e22c",
    "hitokoto": "南天寂静亮星少，北落师门赛明灯",
    "type": "c",
    "from": "叙事曲2",
    "from_who": null,
    "creator": "双语之城",
    "creator_uid": 2271,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540975755",
    "length": 15
  },
  {
    "id": 3973,
    "uuid": "3b97e972-0e7d-4a10-934b-f6784d820d36",
    "hitokoto": "御剑于心，且听风吟。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745824",
    "length": 10
  },
  {
    "id": 3974,
    "uuid": "a90fa9af-72ea-4212-a196-e1f65f4a0c18",
    "hitokoto": "断剑重铸之日，骑士归来之时。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745901",
    "length": 14
  },
  {
    "id": 3975,
    "uuid": "23c58182-653e-4e81-b30f-af17f3eef8b2",
    "hitokoto": "吾虽浪迹天涯，却未迷失本心。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745774",
    "length": 14
  },
  {
    "id": 3976,
    "uuid": "07b3ff58-7354-4b82-a58c-4801f0fda9a8",
    "hitokoto": "时间不在于你拥有多少，而在于你怎样使用。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745654",
    "length": 20
  },
  {
    "id": 3977,
    "uuid": "db3f401d-723f-4f94-aa11-2c45b040f98a",
    "hitokoto": "如果碰壁，就用力把它碰穿。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540746009",
    "length": 13
  },
  {
    "id": 3978,
    "uuid": "927db327-5c72-4b6f-98f8-2c9066f48da5",
    "hitokoto": "落叶的一生，只是为了归根吧。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745598",
    "length": 14
  },
  {
    "id": 3979,
    "uuid": "d6282a33-a684-42c9-b083-111198bcd123",
    "hitokoto": "我于杀戮之中盛放，亦如黎明中的花朵。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745628",
    "length": 18
  },
  {
    "id": 3980,
    "uuid": "6de1b1f4-5128-4183-bb06-891afd271bde",
    "hitokoto": "我伤心的时候，你会不会认为我也是在搞笑？",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745529",
    "length": 20
  },
  {
    "id": 3981,
    "uuid": "8c736875-cc84-4d24-9ae7-e7970c19283c",
    "hitokoto": "生命，不过只是一场骗局，从你开始呼吸的那一刻起，你就已经在慢慢死亡了。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745503",
    "length": 35
  },
  {
    "id": 3993,
    "uuid": "9e831540-bd66-4f85-84e2-b3d0b41be999",
    "hitokoto": "这个国家的大地是活的，正如神创造这片大地时那样。",
    "type": "c",
    "from": "东方非想天则",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539689387",
    "length": 24
  },
  {
    "id": 3995,
    "uuid": "bbe3eb25-1495-4072-836f-ee107da7b708",
    "hitokoto": "英雄，愿你有一份不悔的爱情！",
    "type": "c",
    "from": "魔兽世界",
    "from_who": null,
    "creator": "wu qingfeng",
    "creator_uid": 2225,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540018510",
    "length": 14
  },
  {
    "id": 4001,
    "uuid": "66082e5a-48fb-4b55-ba5f-ca97c386911c",
    "hitokoto": "不管什么时候，能够改变世界的人都是一心追逐梦想的人。",
    "type": "c",
    "from": "口袋妖怪",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540047853",
    "length": 26
  },
  {
    "id": 4002,
    "uuid": "77d8051f-5754-44ef-8491-da61bc9acf5b",
    "hitokoto": "这个世界上并没有绝对的强大或弱小。强大亦是弱小，弱小亦是强大。",
    "type": "c",
    "from": "口袋妖怪",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540047920",
    "length": 31
  },
  {
    "id": 4003,
    "uuid": "e498e442-79ea-4123-9d8c-c0b8392830a0",
    "hitokoto": "纵然身朽去，心美亦永恒。",
    "type": "c",
    "from": "口袋妖怪",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540047967",
    "length": 12
  },
  {
    "id": 4029,
    "uuid": "c3fbc1c5-4d5e-4914-90e6-67175a21a044",
    "hitokoto": "那一张张卡牌上，都写满了你的名字，我总是告诉自己，哪一张没有你的名字，我就会忘记你。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540746133",
    "length": 42
  },
  {
    "id": 4089,
    "uuid": "c406a957-7d1d-42b0-9740-577e7e7e5ffe",
    "hitokoto": "我想你一定很想知道，你昏迷了多长时间……",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538826689",
    "length": 20
  },
  {
    "id": 4090,
    "uuid": "a975b7d6-04cf-45b2-9ea9-09de9bea6201",
    "hitokoto": "寻觅归乡之路，一次一颗子弹",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538826778",
    "length": 13
  },
  {
    "id": 4091,
    "uuid": "8e933148-9cff-43b7-91dd-5d2df83e387d",
    "hitokoto": "一场宴会上喝掉的酒，应该与流出的血一样多",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538826875",
    "length": 20
  },
  {
    "id": 4092,
    "uuid": "d2719319-06bd-4623-8346-9a5e1d0795cb",
    "hitokoto": "找到迷失于黑夜的少女，这便是改写你命运的咒语",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538826926",
    "length": 22
  },
  {
    "id": 4093,
    "uuid": "d9b81e67-c209-49b5-bb3a-ffdb27e15d8c",
    "hitokoto": "人与人的羁绊是真正的力量之源",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538827017",
    "length": 14
  },
  {
    "id": 4094,
    "uuid": "70fa988e-1958-4a6e-bbd2-febd23f7f1ca",
    "hitokoto": "亲爱的，你的心在哪里？",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538827044",
    "length": 11
  },
  {
    "id": 4095,
    "uuid": "424e56ab-1fad-46c2-b477-1d28d92b50f7",
    "hitokoto": "在凄惨的处境中回忆幸福，是世间最大的痛苦",
    "type": "c",
    "from": "少女前线",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538827060",
    "length": 20
  },
  {
    "id": 4100,
    "uuid": "1c80ee0f-47db-459f-8f90-4fe6929892bc",
    "hitokoto": "那些褪色后的记忆，人们会将之镌刻在内心的最深处。所有的梦都是另一个现实。请不要忘记。",
    "type": "c",
    "from": "口袋妖怪",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540048011",
    "length": 42
  },
  {
    "id": 4116,
    "uuid": "5cd6c2c5-31a3-40c4-b8dd-f48a8950ece9",
    "hitokoto": "Death is like the wind; always by my side. 死亡如风，常伴吾身。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745385",
    "length": 53
  },
  {
    "id": 4117,
    "uuid": "604013a8-4371-4310-a8b3-7a14038260cd",
    "hitokoto": "My honor left a long time ago. 吾之荣耀，离别已久。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "leo12",
    "creator_uid": 2264,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540745436",
    "length": 41
  },
  {
    "id": 4154,
    "uuid": "f4a21f88-15bc-45e0-a76a-1dfe67b53699",
    "hitokoto": "我们都是在不曾谋面之张开的神手掌上起舞的命运的奴隶。",
    "type": "c",
    "from": "11eyes",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544426791",
    "length": 26
  },
  {
    "id": 4155,
    "uuid": "c995f44c-4221-4110-8df2-b4fca5d8b3d3",
    "hitokoto": "流淌的命运之河的终点，也许在这一刻就被决定好了。",
    "type": "c",
    "from": "11eyes",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544426836",
    "length": 24
  },
  {
    "id": 4161,
    "uuid": "59e299b2-1a68-474e-abc1-890160d9e55c",
    "hitokoto": "必须有人浴血奋战，世上才有自由可言",
    "type": "c",
    "from": "激战2",
    "from_who": null,
    "creator": "大大大萝卜",
    "creator_uid": 2490,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544916975",
    "length": 17
  },
  {
    "id": 4175,
    "uuid": "411866be-e5eb-4388-a26d-6f9be6273864",
    "hitokoto": "这个世界需要更多的英雄！",
    "type": "c",
    "from": "Overwatch",
    "from_who": null,
    "creator": "頑張って！",
    "creator_uid": 2534,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545476801",
    "length": 12
  },
  {
    "id": 4177,
    "uuid": "a8fd2806-7f3e-4d65-8a02-28e6c0237e3b",
    "hitokoto": "荣誉之于生死，救赎之于荣誉",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547741532",
    "length": 13
  },
  {
    "id": 4178,
    "uuid": "46b8fc39-a767-423b-af02-e5197e162b54",
    "hitokoto": "不要随便对女生做承诺,尤其是在你没有把握的情况下。",
    "type": "c",
    "from": "光环:士官长",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547787653",
    "length": 25
  },
  {
    "id": 4179,
    "uuid": "4fb1bebc-031f-40bd-b7db-17e9e4c4abac",
    "hitokoto": "我也许不是好人，也不是坏人，但肯定不是小人。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788164",
    "length": 22
  },
  {
    "id": 4183,
    "uuid": "9fc2aaae-40a8-4367-bd50-ce15a84a4d94",
    "hitokoto": "愿人类圣光永存！",
    "type": "c",
    "from": "尼尔-机械纪元",
    "from_who": null,
    "creator": "大大大萝卜",
    "creator_uid": 2490,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544916715",
    "length": 8
  },
  {
    "id": 4184,
    "uuid": "f6f5c7b7-fd60-4a2f-b998-b044c3e4fc14",
    "hitokoto": "生者，生者，路化冰河。",
    "type": "c",
    "from": "g-string",
    "from_who": null,
    "creator": "redangel",
    "creator_uid": 2499,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545042248",
    "length": 11
  },
  {
    "id": 4231,
    "uuid": "7cf50ab6-912a-4cd5-9cb4-18d10204dc5d",
    "hitokoto": "当你手里有锤子，那么敌人就是钉子。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547741307",
    "length": 17
  },
  {
    "id": 4232,
    "uuid": "dab78699-ba35-4eb2-93ed-c9ee7c785191",
    "hitokoto": "我曾经也许是个好人，但现在，我只是个士兵。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547741578",
    "length": 21
  },
  {
    "id": 4234,
    "uuid": "beb227aa-9103-40ad-b41b-b35321b1954c",
    "hitokoto": "云外有天，年月有歌。",
    "type": "c",
    "from": "光环:士官长",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547787688",
    "length": 10
  },
  {
    "id": 4235,
    "uuid": "9fe5db6b-f62c-4d27-96b7-c1128be2d988",
    "hitokoto": "每个人都必须找到自己的使命。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547741654",
    "length": 14
  },
  {
    "id": 4237,
    "uuid": "7f3fe72d-fc01-4904-adf5-0041a1175d2e",
    "hitokoto": "我受到了召唤，我必须回应，一如既往。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788337",
    "length": 18
  },
  {
    "id": 4238,
    "uuid": "54aca60f-0b27-46bb-9c25-5162e4bfbed7",
    "hitokoto": "为荣耀而生，为荣誉而死。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547788365",
    "length": 12
  },
  {
    "id": 4243,
    "uuid": "5264bc11-9da2-4048-b9e2-a255ee4e471a",
    "hitokoto": "双脚着地，踏入地狱。命运在最后一瞬间已经决定，尘土飞扬的大地，是地狱伞兵最后的归宿……",
    "type": "c",
    "from": "HALO",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547789710",
    "length": 43
  },
  {
    "id": 4249,
    "uuid": "719d79cf-7978-4edd-8589-df19b3f1fed6",
    "hitokoto": "成败就此一战，我们必须拼尽全力。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547797350",
    "length": 16
  },
  {
    "id": 4250,
    "uuid": "3222f2ef-cb83-4a5a-a46c-f5154b8e95de",
    "hitokoto": "勇气并非来自体力，而是来自不屈不挠的意志。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547797403",
    "length": 21
  },
  {
    "id": 4251,
    "uuid": "56082186-b690-4b5a-8779-5a786476027d",
    "hitokoto": "真正的大师，如艺术一般。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547797470",
    "length": 12
  },
  {
    "id": 4256,
    "uuid": "5a3543dc-6483-40d0-81a4-bdb67a5b70c9",
    "hitokoto": "归期未如佳期至，巴山夜雨留荒词。",
    "type": "c",
    "from": "剑网3",
    "from_who": null,
    "creator": "斟酒",
    "creator_uid": 2651,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547977215",
    "length": 16
  },
  {
    "id": 4261,
    "uuid": "de9d46a1-ef61-465d-b9b4-610448e1fa41",
    "hitokoto": "正因为不会发生，所以才叫奇迹。",
    "type": "c",
    "from": "Kanon",
    "from_who": null,
    "creator": "ouuan",
    "creator_uid": 2676,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548555361",
    "length": 15
  },
  {
    "id": 4264,
    "uuid": "66235011-7c74-4da7-bcb9-14f887f8b062",
    "hitokoto": "你充满了决心。",
    "type": "c",
    "from": "UNDERTALE",
    "from_who": null,
    "creator": "abc2237512422",
    "creator_uid": 1873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548753213",
    "length": 7
  },
  {
    "id": 4313,
    "uuid": "443e8012-99ed-4229-9a5b-ba9cb9dfbccd",
    "hitokoto": "生命和死亡都是可以搬运的。",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557327280",
    "length": 13
  },
  {
    "id": 4314,
    "uuid": "1509b5bf-2a43-44f6-ab27-0a0cf5213bb1",
    "hitokoto": "每个人都有不愿回想的……记忆，而我能感知到这些。",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557327262",
    "length": 24
  },
  {
    "id": 4331,
    "uuid": "ddeaef22-6224-44cc-898f-dc3d4d3ec8b5",
    "hitokoto": "记住 耐心和寂寞是必不可少的 小心那些活着的家伙 别找死 拥抱黑暗吧",
    "type": "c",
    "from": "亡灵",
    "from_who": null,
    "creator": "callinme",
    "creator_uid": 3093,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555814735",
    "length": 34
  },
  {
    "id": 4367,
    "uuid": "02d7b7eb-ea78-4490-9259-8638f9761776",
    "hitokoto": "我曾踏足山巅，也曾进入低谷，二者都让我受益良多！",
    "type": "c",
    "from": "瓦罗兰之盾 塔里克",
    "from_who": null,
    "creator": "海人",
    "creator_uid": 2120,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552132221",
    "length": 24
  },
  {
    "id": 4371,
    "uuid": "30f095b8-59fa-4456-80ec-5bf0358da6ab",
    "hitokoto": "阿珍爱上了阿强",
    "type": "c",
    "from": "刺客伍六七",
    "from_who": null,
    "creator": "王兰花蛤",
    "creator_uid": 2889,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555586248",
    "length": 7
  },
  {
    "id": 4396,
    "uuid": "c5ad63ef-a793-4ee3-81f6-ac4bdc09d389",
    "hitokoto": "纵使疾风起，皇族不言弃。",
    "type": "c",
    "from": "Royal Never GIve Up",
    "from_who": null,
    "creator": "卢黑黑",
    "creator_uid": 2967,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553949558",
    "length": 12
  },
  {
    "id": 4421,
    "uuid": "6f2582a0-cf84-462c-99a1-348e4140530f",
    "hitokoto": "一剑！一念！",
    "type": "c",
    "from": "亚索",
    "from_who": null,
    "creator": "羽泉果子",
    "creator_uid": 3042,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555065486",
    "length": 6
  },
  {
    "id": 4431,
    "uuid": "399f3506-5071-4f41-946b-0eb50a7dc41f",
    "hitokoto": "梦比现实更易侵蚀人的精神，刻意准备的梦是危险的。",
    "type": "c",
    "from": "东方绀珠传 ～ Legacy of Lunatic Kingdom.",
    "from_who": null,
    "creator": "rvalue",
    "creator_uid": 3213,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557547454",
    "length": 24
  },
  {
    "id": 4432,
    "uuid": "464f69fd-4d56-4548-832e-53dd1724c85d",
    "hitokoto": "真正的恐怖，存在于约定俗成的恐怖之外。",
    "type": "c",
    "from": "东方永夜抄 ～ Imperishable Night.",
    "from_who": null,
    "creator": "rvalue",
    "creator_uid": 3213,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557547691",
    "length": 19
  },
  {
    "id": 4448,
    "uuid": "3572c8c8-3d53-47af-a142-5ebf47b26cb5",
    "hitokoto": "明天会吹拂着明天的风。",
    "type": "c",
    "from": "Summer Pockets",
    "from_who": null,
    "creator": "Alex Cui",
    "creator_uid": 3308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559390689",
    "length": 11
  },
  {
    "id": 4449,
    "uuid": "880c967a-a4a1-4332-a5b6-afa94d5f5362",
    "hitokoto": "虽然，灯塔已经失去了光明……但是，只要有你的那首歌在，就一定能将那些人再次导向此方。",
    "type": "c",
    "from": "Summer Pockets",
    "from_who": null,
    "creator": "Alex Cui",
    "creator_uid": 3308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559390671",
    "length": 42
  },
  {
    "id": 4452,
    "uuid": "0367d5f9-963b-42db-88fd-92d153b7a280",
    "hitokoto": "谢谢，这个世界需要更多的英雄。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "你家炸了",
    "creator_uid": 3557,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564109283",
    "length": 15
  },
  {
    "id": 4463,
    "uuid": "10d758ec-d430-4be1-b0a1-6af8df886b60",
    "hitokoto": "见过我家那只可爱的宠物么？它的名字叫大白。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567970791",
    "length": 21
  },
  {
    "id": 4466,
    "uuid": "a895dce0-1d95-49b1-8502-0add47ba0f33",
    "hitokoto": "别人的幸福，你的地狱",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567583565",
    "length": 10
  },
  {
    "id": 4472,
    "uuid": "3890a83c-7217-45e3-9636-1b24205d6b05",
    "hitokoto": "就算我们知道了彼此总有一天会分别，现在的时光，也绝不是没有意义的。",
    "type": "c",
    "from": "Summer Pockets",
    "from_who": null,
    "creator": "Alex Cui",
    "creator_uid": 3308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559390711",
    "length": 33
  },
  {
    "id": 4473,
    "uuid": "e9319e0d-b80b-4d7a-b1ee-7da02765c6f0",
    "hitokoto": "我会穿越那七大海洋，去和你相见。",
    "type": "c",
    "from": "Summer Pockets",
    "from_who": null,
    "creator": "Alex Cui",
    "creator_uid": 3308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559390743",
    "length": 16
  },
  {
    "id": 4474,
    "uuid": "b28d2831-ef0c-4914-b6e5-51fdf80c6db1",
    "hitokoto": "帮助孩子，去实现他的梦想，对大人来说，那是无上的喜悦。",
    "type": "c",
    "from": "Summer Pockets",
    "from_who": null,
    "creator": "Alex Cui",
    "creator_uid": 3308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559390909",
    "length": 27
  },
  {
    "id": 4500,
    "uuid": "6c231d19-63cb-4d80-a180-5acb88aebf74",
    "hitokoto": "为了我，你就永远当个废物吧；为了能让我好好努力，就一生，都成为我的负担吧。",
    "type": "c",
    "from": "白色相簿2",
    "from_who": null,
    "creator": "birchtree",
    "creator_uid": 3455,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111224",
    "length": 37
  },
  {
    "id": 4524,
    "uuid": "fc576dbe-c334-4ac6-85fe-3479440a52fe",
    "hitokoto": "生于黑暗，侍奉光明。万物皆虚，万事皆允。",
    "type": "c",
    "from": "刺客信条",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562980825",
    "length": 20
  },
  {
    "id": 4527,
    "uuid": "c7eb8f3f-6d80-4b85-a78b-6393b2d41775",
    "hitokoto": "我们的工作是搬运生命和死亡。",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562981380",
    "length": 14
  },
  {
    "id": 4529,
    "uuid": "4041e551-da19-4b24-8fda-b2db22ed6400",
    "hitokoto": "如果争端能够避免，那我们应当沉默——如果战斗是必须的，那就战斗到最后！",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562981444",
    "length": 35
  },
  {
    "id": 4530,
    "uuid": "fb23988f-46a1-4634-a858-c6fb9ea27ea6",
    "hitokoto": "来吧！在地狱咆哮吧！为诞生的喜悦，为诞生的憎恨，为诞生的绝望——凛然咆哮吧！",
    "type": "c",
    "from": "Fate / Grand Order",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562981549",
    "length": 38
  },
  {
    "id": 4531,
    "uuid": "b5bfcce5-9f10-40fe-91c0-ca41c25738b6",
    "hitokoto": "于此——聆听吧！汝之晚钟已然敲响！",
    "type": "c",
    "from": "Fate / Grand Order",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562981931",
    "length": 17
  },
  {
    "id": 4534,
    "uuid": "57e87bca-aac8-4c09-9436-d581f18e9720",
    "hitokoto": "欢迎回家，Dr。",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562991333",
    "length": 8
  },
  {
    "id": 4547,
    "uuid": "8c3584b6-2b53-4503-a08f-a4bcefb2ae78",
    "hitokoto": "我是他的盾牌，我是他的利刃。我深知他，连同他的过去和未来。",
    "type": "c",
    "from": "光环:士官长",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563363747",
    "length": 29
  },
  {
    "id": 4560,
    "uuid": "f6f52fd8-17d8-43e6-a850-91e6591b2251",
    "hitokoto": "我受到了召唤，我必须回应，一如既往。",
    "type": "c",
    "from": "守望先锋",
    "from_who": null,
    "creator": "你家炸了",
    "creator_uid": 3557,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564109239",
    "length": 18
  },
  {
    "id": 4567,
    "uuid": "0c1e6c47-5929-44fa-9b20-3c81f4161831",
    "hitokoto": "龙真的是从人们的愿望和想法中诞生的吗？",
    "type": "c",
    "from": "LIEat",
    "from_who": null,
    "creator": "Stapx Steve",
    "creator_uid": 3602,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564906757",
    "length": 19
  },
  {
    "id": 4591,
    "uuid": "dd63ccd3-73ce-4b6e-b03c-9aa369bae99c",
    "hitokoto": "消磨时间尚有更好的方法。想不想尝试一下？",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "Alpha1022",
    "creator_uid": 2094,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566798374",
    "length": 20
  },
  {
    "id": 4606,
    "uuid": "757ee3a7-8f4f-4eb2-a065-8af8eed04817",
    "hitokoto": "这个人好弱啊，真的是我们的指挥使吗？",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567583621",
    "length": 18
  },
  {
    "id": 4607,
    "uuid": "73c8c9a4-3eb3-42d0-a5c5-582853f992dc",
    "hitokoto": "厌倦的人何止是你呢……但我还会继续等待下去，我必须继续等待下去",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567584354",
    "length": 31
  },
  {
    "id": 4609,
    "uuid": "2ec6096f-5d3b-45ca-be3e-5a7e30adb824",
    "hitokoto": "如果人类都是神之子的话——是否愿意给我…这个不听话的逆子一点奖赏？",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567584635",
    "length": 33
  },
  {
    "id": 4610,
    "uuid": "69b41e5c-3538-4f9e-b6c9-64cd63d21f3b",
    "hitokoto": "我觉得世界无聊，是因为我的世界本身已经足够有趣了",
    "type": "c",
    "from": "永远的七日之都 璐璐",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567584926",
    "length": 24
  },
  {
    "id": 4611,
    "uuid": "40c574b0-c599-44b6-83d2-205f78cb7600",
    "hitokoto": "红尘往事付流水，忘尽俗缘始得真，一饮而尽，再醉千年",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567585069",
    "length": 25
  },
  {
    "id": 4612,
    "uuid": "1d041940-aa6f-48a8-a8f2-2036795042ce",
    "hitokoto": "以必将褪色的誓言，守护无法实现的愿望",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567585274",
    "length": 18
  },
  {
    "id": 4613,
    "uuid": "6ae07ff3-0f14-4cb4-bfc3-18db09c3b498",
    "hitokoto": "你要的未来，就是这个样子吗？",
    "type": "c",
    "from": "永远的七日之都",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567585713",
    "length": 14
  },
  {
    "id": 4626,
    "uuid": "f0f9ddf9-5815-47d7-9a38-da150d2ea22f",
    "hitokoto": "这颗心，像青天一样恢宏！",
    "type": "c",
    "from": "王者荣耀",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567970243",
    "length": 12
  },
  {
    "id": 4630,
    "uuid": "51e8f7ea-ee3c-49e1-8c12-9d33a5695b97",
    "hitokoto": "愿吾妹，无拘无束如沧海之风，纵情闪耀如夜空之星。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567970934",
    "length": 24
  },
  {
    "id": 4776,
    "uuid": "1d94b46b-7932-4b68-81e3-54ad69dc9357",
    "hitokoto": "白天四处回响的学生们的喧嚣声全无踪迹。连虫鸣声，都像是从别的世界传来的。",
    "type": "c",
    "from": "駄作",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370822",
    "length": 36
  },
  {
    "id": 4815,
    "uuid": "0bc06e08-276d-45f3-affd-42ad968033c0",
    "hitokoto": "我发现，勇气根本靠不住，只有完全的疯狂才有意义。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "心上猫",
    "creator_uid": 4142,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572052788",
    "length": 24
  },
  {
    "id": 4892,
    "uuid": "145f39d9-4d80-4e6d-86e7-7075ad6ca7ad",
    "hitokoto": "就连你所保护的人都背叛了你，你还在坚持什么？因为无人愿意挺身而出！",
    "type": "c",
    "from": "刺客信条",
    "from_who": null,
    "creator": "Love丶Aimer",
    "creator_uid": 4338,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574513405",
    "length": 33
  },
  {
    "id": 4988,
    "uuid": "7ca3babd-7a93-4c32-958b-89481e8241a5",
    "hitokoto": "黄油嘴边讲，纯爱心中藏。废萌永不倒，甜作放光芒。",
    "type": "c",
    "from": "galgame",
    "from_who": null,
    "creator": "悠远的苍穹",
    "creator_uid": 4871,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496134",
    "length": 24
  },
  {
    "id": 5068,
    "uuid": "1aa7836b-6fc8-48f0-a41c-eeee03e887f2",
    "hitokoto": "I see the player you mean.",
    "type": "c",
    "from": "终末之诗",
    "from_who": "Julian Gough",
    "creator": "狗毛小窝",
    "creator_uid": 4209,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581921821",
    "length": 26
  },
  {
    "id": 5149,
    "uuid": "259964a4-4467-41dd-841d-801b332b889e",
    "hitokoto": "在我死后，还有谁能理解你呢？还有谁能陪你一同前行呢？朋友啊……\r\n一想到你今后将孤独地活下去，我就不禁泪水长流……",
    "type": "c",
    "from": "FGO",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575609196",
    "length": 57
  },
  {
    "id": 5150,
    "uuid": "ca2a1ff2-3213-4c3c-9b0d-713de68462ad",
    "hitokoto": "爱情会轻易转换为憎恨，正因为你如此被深爱，才会遭到人们的憎恨。",
    "type": "c",
    "from": "FGO",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575609130",
    "length": 31
  },
  {
    "id": 5151,
    "uuid": "ce78c859-2b19-49c3-9219-03b433b1c2b9",
    "hitokoto": "我在人民的祈求下成为王后。没有民众，王后怎么能称得上王后呢？",
    "type": "c",
    "from": "FGO",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575609082",
    "length": 30
  },
  {
    "id": 5302,
    "uuid": "adec96c8-ff5e-4ef4-a22d-601d3b45978f",
    "hitokoto": "走在未知的道路上，不能停也不能回头。",
    "type": "c",
    "from": "异次元通讯",
    "from_who": null,
    "creator": "Miko",
    "creator_uid": 5305,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584521821",
    "length": 18
  },
  {
    "id": 5309,
    "uuid": "eb3d10ab-cd61-4803-923d-60e0dc4d7361",
    "hitokoto": "这真是美好的一天，鸟儿在歌唱，鲜花在绽放……在这样的一天里，像你这样的孩子……应该在地狱里燃烧。",
    "type": "c",
    "from": "Undertale",
    "from_who": "Sans",
    "creator": "蓝色变革",
    "creator_uid": 5563,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584789383",
    "length": 48
  },
  {
    "id": 5344,
    "uuid": "87cc2621-c6e3-46bd-bd98-c4c6c02c2026",
    "hitokoto": "瞬光斩黯黮，昭明破晦夜。",
    "type": "c",
    "from": "巫师3",
    "from_who": "杰洛特",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1585290984",
    "length": 12
  },
  {
    "id": 5346,
    "uuid": "9b296a8f-45ac-47f1-b685-d1cdc0aab111",
    "hitokoto": "大佬永远都觉得自己是萌新。",
    "type": "c",
    "from": "彩虹六号",
    "from_who": "SPC",
    "creator": "萌萌哒SPC",
    "creator_uid": 5646,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585277147",
    "length": 13
  },
  {
    "id": 5373,
    "uuid": "f733fbce-0f4d-4649-9de3-16016f4966a4",
    "hitokoto": "教条是一种提醒，并且要你去寻求智慧。",
    "type": "c",
    "from": "刺客信条",
    "from_who": null,
    "creator": "luofan65",
    "creator_uid": 5704,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585620820",
    "length": 18
  },
  {
    "id": 5394,
    "uuid": "29143113-65e6-45e6-b944-c663ffa56ce2",
    "hitokoto": "亲眼所见，亦非真实。",
    "type": "c",
    "from": "第五人格",
    "from_who": null,
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585366171",
    "length": 10
  },
  {
    "id": 5414,
    "uuid": "549ba2f1-658e-4f3a-893f-88307782bd5b",
    "hitokoto": "开始的敌人和最后一个敌人，都是你自己。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "镜",
    "creator": "Soiltary、K",
    "creator_uid": 3915,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585733973",
    "length": 19
  },
  {
    "id": 5415,
    "uuid": "ace34e49-4e52-4a30-b150-99360ae80be2",
    "hitokoto": "输给谁都可以，唯独不能输给自己。",
    "type": "c",
    "from": "Fate/Stay night",
    "from_who": "卫宫士郎",
    "creator": "Emiya",
    "creator_uid": 5755,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585814519",
    "length": 16
  },
  {
    "id": 5417,
    "uuid": "83ac11ef-1cab-4ae4-a869-065647e64ef6",
    "hitokoto": "万物皆虚，万物皆允。",
    "type": "c",
    "from": "刺客信条",
    "from_who": null,
    "creator": "luofan65",
    "creator_uid": 5704,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585620786",
    "length": 10
  },
  {
    "id": 5421,
    "uuid": "4a3de254-eae7-43a8-be3a-5dd591ad15ce",
    "hitokoto": "You know,that day…in Seattle…The day Dad was shot.I think about it every day…and I would give anything to change what happened…but I can’t.",
    "type": "c",
    "from": "LIFE IS STRANGE 2",
    "from_who": "Sean Diaz",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585815608",
    "length": 139
  },
  {
    "id": 5422,
    "uuid": "dfc0c998-62e7-4a62-990e-10a15d9bd84f",
    "hitokoto": "飘零的孤鸟，也有权利寻求幸福啊。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": null,
    "creator": "Cat",
    "creator_uid": 5756,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585817923",
    "length": 16
  },
  {
    "id": 5435,
    "uuid": "327f6d67-2795-4970-b58a-2f6d7f3e38d7",
    "hitokoto": "不会让你们碰那个人类一根手指的！",
    "type": "c",
    "from": "東方永夜抄",
    "from_who": null,
    "creator": "Solakawa",
    "creator_uid": 5740,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585789100",
    "length": 16
  },
  {
    "id": 6068,
    "uuid": "92489407-a590-4a82-803c-19788e91cbe7",
    "hitokoto": "“做到最牛”就是我所订下的每日标准，不管到哪儿都是。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "德莱文",
    "creator": "KangKang",
    "creator_uid": 5192,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588001227",
    "length": 26
  },
  {
    "id": 6070,
    "uuid": "ed14c264-a106-4059-8e80-f9ac6db3426a",
    "hitokoto": "用悲伤来治愈会摧毁它。而悲伤是它的私人事务。我们不能干涉。",
    "type": "c",
    "from": "Minecraft",
    "from_who": "终末之诗",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063568",
    "length": 29
  },
  {
    "id": 6071,
    "uuid": "43ab38de-ba51-45c2-8b14-ec1410253d97",
    "hitokoto": "宇宙说：你所斗争的黑暗就在你心中，你所寻找的光明就在你心中。",
    "type": "c",
    "from": "Minecraft",
    "from_who": "终末之诗",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063602",
    "length": 30
  },
  {
    "id": 6110,
    "uuid": "48b7c806-d81e-4bd8-84ba-84d069759d62",
    "hitokoto": "我们就这样，生活在此地并不断离别。",
    "type": "c",
    "from": "崩坏三",
    "from_who": "后崩坏书",
    "creator": "星野鈴美",
    "creator_uid": 6015,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588512410",
    "length": 17
  },
  {
    "id": 6111,
    "uuid": "6cd3d023-1815-46e2-8a8f-c84de091b445",
    "hitokoto": "so leben wir und nehmen immer Abschied.",
    "type": "c",
    "from": "崩坏三",
    "from_who": "后崩坏书",
    "creator": "星野鈴美",
    "creator_uid": 6015,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588512447",
    "length": 39
  },
  {
    "id": 6161,
    "uuid": "7dfb4595-a1b9-46a8-871e-c157382fa188",
    "hitokoto": "夜醒众人漫漫夜，宝船乘风破浪声。",
    "type": "c",
    "from": "樱之诗",
    "from_who": null,
    "creator": "怀表小兔",
    "creator_uid": 6212,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589440817",
    "length": 16
  },
  {
    "id": 6240,
    "uuid": "0f0d2b12-5607-4ddb-977a-f3ca7fef690d",
    "hitokoto": "Can you hear me?",
    "type": "c",
    "from": "CytusⅡ",
    "from_who": null,
    "creator": "Empiso",
    "creator_uid": 4540,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591247921",
    "length": 16
  },
  {
    "id": 6252,
    "uuid": "c4133ac7-6914-4164-ba1a-5acf4c1bf91e",
    "hitokoto": "Via Soul!",
    "type": "c",
    "from": "Sdorica",
    "from_who": null,
    "creator": "Empiso",
    "creator_uid": 4540,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591143546",
    "length": 9
  },
  {
    "id": 6277,
    "uuid": "4df576fc-1a0c-48d2-81a9-3a85af89ed86",
    "hitokoto": "优雅，永不过时。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": null,
    "creator": "昊游",
    "creator_uid": 6448,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591951106",
    "length": 8
  },
  {
    "id": 6282,
    "uuid": "b40ea71a-bbe6-43f4-b7d2-3921f8f0d11f",
    "hitokoto": "Never left without saying goodbye.",
    "type": "c",
    "from": "Deemo",
    "from_who": null,
    "creator": "Empiso",
    "creator_uid": 4540,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592287210",
    "length": 34
  },
  {
    "id": 6304,
    "uuid": "92d296af-5ec9-49cc-b8fe-a3f86315aa32",
    "hitokoto": "自己的痛苦别人无法理解。",
    "type": "c",
    "from": "三色绘恋s",
    "from_who": "叶心",
    "creator": "preferjie",
    "creator_uid": 6428,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592917524",
    "length": 12
  },
  {
    "id": 6305,
    "uuid": "72901632-44de-4004-81de-1d88cb749372",
    "hitokoto": "长城之上，是千亿的星空，星空之上，是不灭的守望。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "李信",
    "creator": "long",
    "creator_uid": 6693,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1594580394",
    "length": 24
  },
  {
    "id": 6320,
    "uuid": "5df62ea1-4821-4389-8f6b-26a1d59fb592",
    "hitokoto": "我多希望恶魔的力量不要施展，希望这一切都不过是我的幻想……不，不对。我祈祷的是这恶魔之力……一定要彻底断绝凶手的性命！",
    "type": "c",
    "from": "大逆转裁判2",
    "from_who": "比莉简·格林",
    "creator": "水仓云雀",
    "creator_uid": 6538,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592997529",
    "length": 59
  },
  {
    "id": 6321,
    "uuid": "de1d9997-d9fc-4500-8630-94e2c76f5af0",
    "hitokoto": "我的名字，是奥里。",
    "type": "c",
    "from": "精灵与萤火意志",
    "from_who": "奥里",
    "creator": "水仓云雀",
    "creator_uid": 6538,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592997571",
    "length": 9
  },
  {
    "id": 6322,
    "uuid": "29141287-a1e2-4cca-ac2f-633d0578ce8f",
    "hitokoto": "一件善举：一只莫基因为你与家人团聚了。",
    "type": "c",
    "from": "精灵与萤火意志",
    "from_who": "物品栏说明",
    "creator": "水仓云雀",
    "creator_uid": 6538,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592997675",
    "length": 19
  },
  {
    "id": 6351,
    "uuid": "00158a87-8647-4f56-a84f-34e11b531856",
    "hitokoto": "纵使长夜漫漫永劫无期，我也要化身星辰点燃希望，你的誓言由我来实现。",
    "type": "c",
    "from": "崩坏3",
    "from_who": null,
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593567470",
    "length": 33
  },
  {
    "id": 6352,
    "uuid": "f6e447a5-30fb-4c81-b27f-11ee6ac390eb",
    "hitokoto": "醒时空为梦一场，事事俱忘，何处是吾乡。",
    "type": "c",
    "from": "崩坏3",
    "from_who": "符华",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593567776",
    "length": 19
  },
  {
    "id": 6353,
    "uuid": "435fc645-1fe2-4d29-a0a6-b62e11b47bd2",
    "hitokoto": "怡然独向九霄中， 坐看浮生作梦。",
    "type": "c",
    "from": "符华",
    "from_who": "崩坏3",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593567797",
    "length": 16
  },
  {
    "id": 6354,
    "uuid": "3190fd5e-107c-4b28-a9cb-916b02c48f0d",
    "hitokoto": "纵使黑云蔽日，我也要燃烧天空，带你找到回家的路。",
    "type": "c",
    "from": "崩坏3",
    "from_who": null,
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593567865",
    "length": 24
  },
  {
    "id": 6381,
    "uuid": "6862c1ab-65c9-4899-930c-b40025039c6e",
    "hitokoto": "无论是云中落下的一滴水，还是湖面中微风吹起的一道涟漪，都有她的身影。",
    "type": "c",
    "from": "洛克王国",
    "from_who": "洛克王国",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1595157318",
    "length": 34
  },
  {
    "id": 6489,
    "uuid": "07d5f455-62b8-4a3f-be36-79d27c2a839e",
    "hitokoto": "清晨的花朵，开在黄昏中的残骸之上，一切都会过去，不是吗？",
    "type": "c",
    "from": "«最后一分钟»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386475",
    "length": 28
  },
  {
    "id": 6490,
    "uuid": "4f9fbe08-bc95-4b6d-a6be-cb5d96b3646c",
    "hitokoto": "时间的意义取决于人类：千年如一日，一日复千年。",
    "type": "c",
    "from": "«时光飞逝»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599385467",
    "length": 23
  },
  {
    "id": 6491,
    "uuid": "2fcd691a-ebb0-4cf3-b189-b991de5ee36d",
    "hitokoto": "遗忘，也是种解脱：当人们为之逝去，活下来的为之蒙恨的时候。",
    "type": "c",
    "from": "«最后的老兵»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599385727",
    "length": 29
  },
  {
    "id": 6492,
    "uuid": "bcb06c15-327e-44ae-b215-6db45901607a",
    "hitokoto": "时代变了，但有些事情可还没变呢，大人。",
    "type": "c",
    "from": "«无耻之徒»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599385936",
    "length": 19
  },
  {
    "id": 6493,
    "uuid": "23d7c83d-4f6d-4a31-9a8c-d377f91f45e1",
    "hitokoto": "仆从和主人，多么美妙的爱情故事，愿他们生活在一个能自由相爱的世界吧。",
    "type": "c",
    "from": "核爆前半小时",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386074",
    "length": 34
  },
  {
    "id": 6501,
    "uuid": "67624fdd-6891-4d47-b382-25b3bbff5451",
    "hitokoto": "切尔诺贝利——人间禁地，动物的乐园。",
    "type": "c",
    "from": "«维齐米尔的诅咒»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599389339",
    "length": 18
  },
  {
    "id": 6523,
    "uuid": "dee5c8d4-38df-42af-95f5-a42773de1938",
    "hitokoto": "追求理想的利他主义，与追求道德制高点的自我满足，不仔细观察是没有区别的。",
    "type": "c",
    "from": "«辩护»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599389361",
    "length": 36
  },
  {
    "id": 6531,
    "uuid": "de0bfb70-aaa5-4ff7-9455-7d14333ff43a",
    "hitokoto": "伊甸园的存在，是为证明世界的罪恶。",
    "type": "c",
    "from": "«动物博览园»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599389241",
    "length": 17
  },
  {
    "id": 6541,
    "uuid": "d34c263d-d37f-4753-92bf-047e718f75d5",
    "hitokoto": "没错，都被我，你们的希姆莱爷爷偷走啦！",
    "type": "c",
    "from": "«宝库»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388694",
    "length": 19
  },
  {
    "id": 6542,
    "uuid": "2f1bbfd9-4b7d-4562-bb39-dbc51084e953",
    "hitokoto": "当然是教你们养鸡啦，将优等种的德意志鸡推广到全世界！",
    "type": "c",
    "from": "«无聊»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388727",
    "length": 26
  },
  {
    "id": 6543,
    "uuid": "071fd7d4-a5fd-4574-b1eb-c36b4fd5fc5b",
    "hitokoto": "是我，慈祥的希姆莱爷爷哒！快进来让我摸摸。",
    "type": "c",
    "from": "«奥斯特帕的鬼屋»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388760",
    "length": 21
  },
  {
    "id": 6544,
    "uuid": "fb244557-26cc-4a26-88ed-1f0ed605e96a",
    "hitokoto": "那么究竟是末日的记忆让人心冰冷，还是冰冷带来了那一天的毁灭呢？",
    "type": "c",
    "from": "«遗迹的诅咒»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388815",
    "length": 31
  },
  {
    "id": 6545,
    "uuid": "7784d013-3671-49f7-b31f-562a45a471ae",
    "hitokoto": "现代技术的遗产，跑车与石油，人类永恒的追求，速度与激情。燃烧与腐朽，宁愿燃烧，不愿腐朽！",
    "type": "c",
    "from": "«最后的比赛»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599389040",
    "length": 44
  },
  {
    "id": 6546,
    "uuid": "88d8830c-c674-4575-8071-fb27c8d8348f",
    "hitokoto": "诸行无常、诸法无我、涅槃喧嚣。",
    "type": "c",
    "from": "«老和尚的寓言»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599389218",
    "length": 15
  },
  {
    "id": 6550,
    "uuid": "c4294eb9-a2d3-4def-b324-595779fc10dc",
    "hitokoto": "它们随风飘落，恰好落在一处光滑的斜坡上动弹不得，而后雪崩来了。",
    "type": "c",
    "from": "«大衰退»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386392",
    "length": 31
  },
  {
    "id": 6554,
    "uuid": "10e6b2fc-ccdd-426d-bd5d-269b3e9a034d",
    "hitokoto": "对于德国的奴隶，没有什么比死亡更可怕，感谢这场核战！",
    "type": "c",
    "from": "«最后的自由»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599385962",
    "length": 26
  },
  {
    "id": 6556,
    "uuid": "8643519c-cc44-409f-ad75-05bf9858e807",
    "hitokoto": "予以民众精神上的启蒙和引导，才是真正值得歌颂的正途，愚昧的仪式只会引来更深层的愚昧。",
    "type": "c",
    "from": "«诅咒之书»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386161",
    "length": 42
  },
  {
    "id": 6557,
    "uuid": "34826644-34b8-4306-9e7c-0b9ec1916c2a",
    "hitokoto": "天下大势，顺人心者兴，成功者不一定是最有能力的人，但自然是抓住机会的人。",
    "type": "c",
    "from": "«万世为王»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386221",
    "length": 36
  },
  {
    "id": 6558,
    "uuid": "cb68a01a-2c9a-49ff-a207-a12a37b3c766",
    "hitokoto": "有朝一日，是否会有人纪念他们。",
    "type": "c",
    "from": "«纪念之日»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386368",
    "length": 15
  },
  {
    "id": 6559,
    "uuid": "b25dcdf8-5a26-4ebc-8662-0e4f8b24f47f",
    "hitokoto": "记忆，总会传承下去，无论是用何种方式。",
    "type": "c",
    "from": "«友谊的远征»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386451",
    "length": 19
  },
  {
    "id": 6560,
    "uuid": "4ab781e7-01ff-4752-a116-8f618e1a438b",
    "hitokoto": "革命家与充满血泪的时代，一起走向终结，但那不是结束，后来者还需为己而战。",
    "type": "c",
    "from": "«红小鬼»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386342",
    "length": 36
  },
  {
    "id": 6561,
    "uuid": "c52cb208-fd1b-40c2-85dc-b193a00a03c6",
    "hitokoto": "个人一小步，人类一大步；无论大步还是小步，总是左右世界的步伐。",
    "type": "c",
    "from": "«人类的第二步»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599385534",
    "length": 31
  },
  {
    "id": 6564,
    "uuid": "4565a0f1-e0bb-46e9-a735-e5f75fc5d078",
    "hitokoto": "当代价不再重要，人们也会对恐惧有所遗忘。",
    "type": "c",
    "from": "«复仇»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388590",
    "length": 20
  },
  {
    "id": 6565,
    "uuid": "d4164b0f-1ffc-4c21-828e-20c0f7e300e1",
    "hitokoto": "知识是人类进步的阶梯，万代积累的结果，如果它们失传了，人类的时代也就真正落幕了。",
    "type": "c",
    "from": "«塔罗之书»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387337",
    "length": 40
  },
  {
    "id": 6567,
    "uuid": "20c769e3-96de-41c7-bb38-368dd338660e",
    "hitokoto": "Heaven's net is wide, but there's nothing through.",
    "type": "c",
    "from": "心灵终结",
    "from_who": "友川纪夫",
    "creator": "Fight_xing",
    "creator_uid": 6244,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1600179838",
    "length": 50
  },
  {
    "id": 6569,
    "uuid": "c4dc3050-9b08-4d95-a259-7d315b611312",
    "hitokoto": "人世几回伤往事，山形依旧枕寒流。今逢四海为家日，故垒萧萧芦荻秋。",
    "type": "c",
    "from": "火时代传奇",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387581",
    "length": 32
  },
  {
    "id": 6570,
    "uuid": "586ea844-022b-4684-ab50-a698df181015",
    "hitokoto": "红，是浸满怒火的热血，是行将破晓的天空；黑，是被抛弃的蒙昧世界，是长夜将尽的洪钟。",
    "type": "c",
    "from": "«致一代的毁灭者»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387687",
    "length": 41
  },
  {
    "id": 6572,
    "uuid": "57b44bef-84c2-417e-9f57-6789a3ee443e",
    "hitokoto": "人民是健忘的，但他们总有其他方式去记住。",
    "type": "c",
    "from": "«狂欢节»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387781",
    "length": 20
  },
  {
    "id": 6573,
    "uuid": "8c86b0ca-e7dc-4342-96fb-978ee1a9ebe7",
    "hitokoto": "将科学展示给原始人，他们觉得那是魔法；将魔法展示给现代人，他们总想找出些科学。",
    "type": "c",
    "from": "«万灵药的传说»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599389387",
    "length": 39
  },
  {
    "id": 6574,
    "uuid": "2dc6d6d3-30da-41d5-8dc7-99ad097b5c48",
    "hitokoto": "失去记忆的遗迹只是尊空壳。",
    "type": "c",
    "from": "«滑稽的男人»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388350",
    "length": 13
  },
  {
    "id": 6575,
    "uuid": "cb743422-fe3b-4d3b-9da1-dc792b9a0b36",
    "hitokoto": "年月把拥有变做失去，疲倦的双眼带着期望；今天只有残留的躯壳，迎接光辉岁月。",
    "type": "c",
    "from": "«披头士出售»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599388121",
    "length": 37
  },
  {
    "id": 6576,
    "uuid": "41abb8d8-ae81-4b9c-b8e0-86ed869bef3d",
    "hitokoto": "物质之外亦有精神的世界。",
    "type": "c",
    "from": "«红王公的故事»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387309",
    "length": 12
  },
  {
    "id": 6577,
    "uuid": "5f5b6438-ca22-482c-9d3e-ae5666cccf51",
    "hitokoto": "血缘、亲情与对乡土的依恋，民族的源头，也本是最朴素无华而浪漫的东西。",
    "type": "c",
    "from": "«不再错过»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387361",
    "length": 34
  },
  {
    "id": 6578,
    "uuid": "fd65fe32-97ae-494f-8aa7-ffd5b7198e44",
    "hitokoto": "乱世邯郸生祖龙，书文四方车轨同，青山秋草树丛从。",
    "type": "c",
    "from": "«春秋»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599387274",
    "length": 24
  },
  {
    "id": 6579,
    "uuid": "fe549950-d947-4977-aa6c-39d2ab2069e2",
    "hitokoto": "最后死去的人，是最不幸的。",
    "type": "c",
    "from": "«独面黑暗»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386812",
    "length": 13
  },
  {
    "id": 6581,
    "uuid": "5caedeb8-dbf5-4ebc-9d48-2532e7e5f3d5",
    "hitokoto": "有安全的土地可供耕耘，有家人陪伴身旁，不必为生活担惊受怕，乱世中，平凡大众的奢望不过如此。",
    "type": "c",
    "from": "«自由国度»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386757",
    "length": 45
  },
  {
    "id": 6582,
    "uuid": "6a2c923f-1515-47ae-80ad-c2dc8ce95973",
    "hitokoto": "汹涌的海涛中，传来一缕希望。",
    "type": "c",
    "from": "«永不消逝的电波»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386732",
    "length": 14
  },
  {
    "id": 6584,
    "uuid": "1b9332d0-4627-4c56-8597-f071e793ac48",
    "hitokoto": "同类间的矛盾总会生长在安逸与傲慢里。一旦这温床被打破，可笑的歧视与偏见又算得了什么呢？",
    "type": "c",
    "from": "«可被触碰者»，TNO启示录事件",
    "from_who": "The New Order:Last Days of Europe",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599386582",
    "length": 43
  },
  {
    "id": 6593,
    "uuid": "50968fd1-53ee-4d7a-b563-6fc9b8d30e78",
    "hitokoto": "离别长，欢聚短，若共把酒为歌，且斟余生一酌。",
    "type": "c",
    "from": "烟雨江湖",
    "from_who": "南阳画师",
    "creator": "The发",
    "creator_uid": 7505,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603210152",
    "length": 22
  },
  {
    "id": 6622,
    "uuid": "291c626d-1fc3-4ebe-9ce2-df442d90583c",
    "hitokoto": "在黑暗中，我们看到光明。",
    "type": "c",
    "from": "明日方舟",
    "from_who": "明日方舟",
    "creator": "启玄云天",
    "creator_uid": 7632,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604310397",
    "length": 12
  },
  {
    "id": 6695,
    "uuid": "c886f5fb-a72a-4c58-b8b1-185436383013",
    "hitokoto": "我回来，是为了那些回不来的人。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "Ada",
    "creator": "Ada",
    "creator_uid": 6698,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604798647",
    "length": 15
  },
  {
    "id": 6716,
    "uuid": "e39b4f97-04f6-40a3-ac31-63f3484fe688",
    "hitokoto": "做一杯奶茶，去去不到的地方给想见的人！",
    "type": "c",
    "from": "我的奶茶屋",
    "from_who": "安麻殿",
    "creator": "安麻殿",
    "creator_uid": 7712,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605088927",
    "length": 19
  },
  {
    "id": 6759,
    "uuid": "24ecc04e-dce4-4698-866d-5e921bf02732",
    "hitokoto": "你在乱世中独行，又是否热爱过这一切？",
    "type": "c",
    "from": "狩猎",
    "from_who": "少女前线",
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387379",
    "length": 18
  },
  {
    "id": 6760,
    "uuid": "7e4a27a8-b063-4ca0-a9cc-fb607077fe3c",
    "hitokoto": "来吧，在倒挂的森林里，追寻她的倒影。",
    "type": "c",
    "from": "少女前线 - 喘息",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387419",
    "length": 18
  },
  {
    "id": 6761,
    "uuid": "573cca2b-ca7b-4143-acd0-38ba03dd8008",
    "hitokoto": "既是结束，又是开始。",
    "type": "c",
    "from": "少女前线 - 归墟",
    "from_who": null,
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387445",
    "length": 10
  },
  {
    "id": 6762,
    "uuid": "574aa071-620a-4956-9676-f68ae42f65cd",
    "hitokoto": "牺牲是对信念最后的坚守，他们是为他们的信念而死。 而我们这些活着的人没有资格评判别人的牺牲是否有意义。",
    "type": "c",
    "from": "少女前线",
    "from_who": "安洁",
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387495",
    "length": 51
  },
  {
    "id": 6763,
    "uuid": "74d37b73-cde4-4639-ae3d-6eca791cbc28",
    "hitokoto": "不过有时候，幸存并非意味着幸运。 当离开地狱时，我们很难确认眼前的光芒是不是来自天堂，来自一个梦，还是来自真实的记忆……",
    "type": "c",
    "from": "少女前线",
    "from_who": "指挥官",
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387532",
    "length": 60
  },
  {
    "id": 6764,
    "uuid": "ed875a25-1f46-404f-8b83-f2bbd087480a",
    "hitokoto": "我的经验告诉我，末日迫近时，总会发生奇迹。或者说末日本身就是个奇迹，只要我们从其中活下来。 这一刻，它发生了……我们依靠这个末日，幸存了下来。",
    "type": "c",
    "from": "少女前线",
    "from_who": "指挥官",
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387564",
    "length": 71
  },
  {
    "id": 6765,
    "uuid": "d8f7f7e8-b17f-4349-a865-dc659ca226b8",
    "hitokoto": "他们是士兵，执行命令是他们的天职，哪怕注定走向失败。",
    "type": "c",
    "from": "少女前线",
    "from_who": "K",
    "creator": "xiaoh",
    "creator_uid": 2097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606387709",
    "length": 26
  },
  {
    "id": 6766,
    "uuid": "7b485c6c-3053-47c2-8a46-b569627f981f",
    "hitokoto": "你当做秘密，而我信任你。若不是因为你，我将会长眠。",
    "type": "c",
    "from": "心跳文学部",
    "from_who": "纱世里",
    "creator": "Aaron",
    "creator_uid": 7717,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606390124",
    "length": 25
  },
  {
    "id": 6790,
    "uuid": "3c284f24-5031-4518-aad3-063b531b28c6",
    "hitokoto": "有些错误无法犯两次，有些事绝对不会无趣。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "疾风剑豪▪亚索",
    "creator": "御辞",
    "creator_uid": 7886,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606564518",
    "length": 20
  },
  {
    "id": 6903,
    "uuid": "00dc7b46-015e-4f34-8ae6-6e35b78b67f0",
    "hitokoto": "直到她永久沉睡的那一天，世界啊，请你一定不要终结。",
    "type": "c",
    "from": "eden*",
    "from_who": "榛名亮",
    "creator": "汐咸",
    "creator_uid": 2834,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607832486",
    "length": 25
  },
  {
    "id": 6904,
    "uuid": "e8d0cc05-9461-4d7c-9496-d2530a891812",
    "hitokoto": "这个世界本身啊，应该从未思考过任何事物吧。恶意也好，善意也罢，这类东西肯定是没有的。但是，仅仅，只是路过而已，我们就被它折腾得疲于奔命，因为我们在它眼里如同蚂蚁般微小。",
    "type": "c",
    "from": "青空下的加缪",
    "from_who": "燐",
    "creator": "汐咸",
    "creator_uid": 2834,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607837464",
    "length": 84
  },
  {
    "id": 6929,
    "uuid": "c6cd4072-4f28-409e-9a85-018afa76f675",
    "hitokoto": "生命值得为之而战。",
    "type": "c",
    "from": "魔兽世界",
    "from_who": "红龙女王阿莱克斯塔萨",
    "creator": "幻煞白",
    "creator_uid": 7766,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609843402",
    "length": 9
  },
  {
    "id": 6936,
    "uuid": "3240d133-6a57-496e-a2ee-afffb10286f8",
    "hitokoto": "也许，我们会自由。",
    "type": "c",
    "from": "The New Order:Last Days of Europe",
    "from_who": "高宗武",
    "creator": "Forevercontinent",
    "creator_uid": 7134,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610465132",
    "length": 9
  },
  {
    "id": 6950,
    "uuid": "2434c848-79fe-4979-98d1-6332e7cc42dc",
    "hitokoto": "时间不在于你拥有多少，而在于你怎样去使用。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "艾克",
    "creator": "月笙日暮",
    "creator_uid": 8301,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611313843",
    "length": 21
  },
  {
    "id": 6952,
    "uuid": "5bab2c03-7b3d-436c-b3a8-74842f711836",
    "hitokoto": "去把这个并不完美的世界，变成你所期望的样子。",
    "type": "c",
    "from": "崩坏3",
    "from_who": "姬子",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432033",
    "length": 22
  },
  {
    "id": 6955,
    "uuid": "76d2162f-94df-4348-a013-5167d7c37c27",
    "hitokoto": "愿人类荣光永存。",
    "type": "c",
    "from": "尼尔·机械纪元",
    "from_who": "2b",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432472",
    "length": 8
  },
  {
    "id": 6957,
    "uuid": "d865afaa-475d-4ef3-a830-05631cb1b19e",
    "hitokoto": "我该用什么来回应你的不义。",
    "type": "c",
    "from": "明日方舟",
    "from_who": "阿米娅",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432622",
    "length": 13
  },
  {
    "id": 7017,
    "uuid": "27a88dd7-e35a-40fb-8863-50f9b9256a80",
    "hitokoto": "经历这种痛苦的人，我一个就够了！但为什么你就是不明白呢？！",
    "type": "c",
    "from": "美少女万华镜·理与迷宫的少女",
    "from_who": "莲华",
    "creator": "深见",
    "creator_uid": 8420,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612428830",
    "length": 29
  },
  {
    "id": 7018,
    "uuid": "b52c33c6-5fec-4d82-b487-55526687fae9",
    "hitokoto": "我拒绝，再一次和你分开。",
    "type": "c",
    "from": "美少女万华镜·理与迷宫的少女",
    "from_who": "夏彦深见",
    "creator": "深见",
    "creator_uid": 8420,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612428891",
    "length": 12
  },
  {
    "id": 7019,
    "uuid": "271e1211-11da-49c4-b001-0733ec17e16d",
    "hitokoto": "所谓这个世界的真理，就是由爱所记录下的一切。",
    "type": "c",
    "from": "美少女万华镜·理与迷宫的少女",
    "from_who": "夏彦深见",
    "creator": "深见",
    "creator_uid": 8420,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612428989",
    "length": 22
  },
  {
    "id": 7026,
    "uuid": "59a41e81-ad52-43c8-a7c7-308f9f9969ff",
    "hitokoto": "我曾踏足山巅，也曾跌入谷底，这两者都让我受益良多。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "塔里克",
    "creator": "dfxlm",
    "creator_uid": 8553,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613813347",
    "length": 25
  },
  {
    "id": 7055,
    "uuid": "dfe5e100-a633-43a4-baa2-a1690aa8f406",
    "hitokoto": "外表可是具有欺骗性的。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "妖姬",
    "creator": "dfxlm",
    "creator_uid": 8553,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613812961",
    "length": 11
  },
  {
    "id": 7056,
    "uuid": "ccb12217-cdc6-433c-855c-fd5d01349de1",
    "hitokoto": "有些失误无法犯两次。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "疾风剑豪",
    "creator": "dfxlm",
    "creator_uid": 8553,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613813063",
    "length": 10
  },
  {
    "id": 7065,
    "uuid": "d32b6331-2fac-456a-a0c5-f70a38f3cf57",
    "hitokoto": "新朋友，老对头……奇遇不会老去，陈旧的只有伤疤。",
    "type": "c",
    "from": "明日方舟",
    "from_who": null,
    "creator": "大师",
    "creator_uid": 5617,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613893220",
    "length": 24
  },
  {
    "id": 7091,
    "uuid": "c165d1f2-4587-49ab-a73b-355663f60d0e",
    "hitokoto": "生物趋利避害，生命自私无情。",
    "type": "c",
    "from": "《明日方舟》",
    "from_who": null,
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615652741",
    "length": 14
  },
  {
    "id": 7092,
    "uuid": "2fc8d4f5-f784-4702-99ca-31fb617d6b10",
    "hitokoto": "你能预见，你能准备，你能承受，那你也能胜过不幸。",
    "type": "c",
    "from": "《明日方舟》",
    "from_who": null,
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615652762",
    "length": 24
  },
  {
    "id": 7099,
    "uuid": "969094d4-9ea0-4fce-be13-0eef8913b012",
    "hitokoto": "我要把你叫醒，哪怕赌上我的一切.",
    "type": "c",
    "from": "SummerPocket",
    "from_who": null,
    "creator": "EdgeNeko",
    "creator_uid": 8761,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615991423",
    "length": 16
  },
  {
    "id": 7201,
    "uuid": "40ecdb0b-5c52-40ca-8001-e25a980057cd",
    "hitokoto": "只愿涤荡四方，护得一世之隅。",
    "type": "c",
    "from": "原神",
    "from_who": "米哈游",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615185281",
    "length": 14
  },
  {
    "id": 7214,
    "uuid": "778bda0d-ef72-45d8-afa9-b4ca15844d27",
    "hitokoto": "直面恐惧，创造未来。",
    "type": "c",
    "from": "脑叶公司",
    "from_who": "Project Moon",
    "creator": "carrot",
    "creator_uid": 8780,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616804115",
    "length": 10
  },
  {
    "id": 7238,
    "uuid": "47cfae22-b157-4724-9cf3-1427be0be280",
    "hitokoto": "迄今所有人生都大写着失败，但并不妨碍我继续向前。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "狂铁",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620515794",
    "length": 24
  },
  {
    "id": 7239,
    "uuid": "c30b56b0-ab8e-4068-992c-76639babb2b6",
    "hitokoto": "希望的钥匙，就在奇迹之间。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "老夫子",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516125",
    "length": 13
  },
  {
    "id": 7240,
    "uuid": "419c08a5-a77a-48d2-9326-fe21bf08b12b",
    "hitokoto": "鲁莽，也比怯懦更接近勇敢。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "狂铁",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516498",
    "length": 13
  },
  {
    "id": 7241,
    "uuid": "92baae7f-4891-425e-81db-0163e91c2429",
    "hitokoto": "老夫年少时，也像他们一样，追随神的意志，征战四方。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "老夫子",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620515728",
    "length": 25
  },
  {
    "id": 7242,
    "uuid": "e26cc157-6a27-4fa4-b0a8-86287306f95b",
    "hitokoto": "老夫所在的地方，就是和平的人间界。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "老夫子",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620515921",
    "length": 17
  },
  {
    "id": 7243,
    "uuid": "761223e9-2170-4908-aa63-40c95e792bf0",
    "hitokoto": "侯非侯，王非王，千乘万骑走北芒。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "李信",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516281",
    "length": 16
  },
  {
    "id": 7244,
    "uuid": "5d8041a1-228d-4664-9202-6b7778876857",
    "hitokoto": "卑鄙是卑鄙者的通行证，高尚是高尚者的墓志铭。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "杨戬",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516444",
    "length": 22
  },
  {
    "id": 7245,
    "uuid": "359859ea-e319-42b7-a8a5-a05a329f7f78",
    "hitokoto": "绵延万万里的脊梁，撑起家国傲骨！",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "苏烈",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516605",
    "length": 16
  },
  {
    "id": 7246,
    "uuid": "f12b7b3a-a7eb-4265-a1b9-b0905f78de64",
    "hitokoto": "与其绝望死去 不如纵情燃烧。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "杨戬",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516632",
    "length": 14
  },
  {
    "id": 7247,
    "uuid": "0ead7a07-ddd6-409c-917b-3388af11baeb",
    "hitokoto": "自己选择的路，再荒谬也要走完！",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "关羽",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620516678",
    "length": 15
  },
  {
    "id": 7253,
    "uuid": "3f53df3c-770f-4048-89f3-ca7eff8cf368",
    "hitokoto": "逆流而上吧。",
    "type": "c",
    "from": "《王者荣耀》",
    "from_who": "大乔",
    "creator": "一只叫一行的喵",
    "creator_uid": 9261,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620878557",
    "length": 6
  },
  {
    "id": 7254,
    "uuid": "05133a3d-e72e-49e1-983c-b9b829822e15",
    "hitokoto": "无欲无求，笑口常开。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "元歌",
    "creator": "信仰需长存",
    "creator_uid": 9225,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620975938",
    "length": 10
  },
  {
    "id": 7268,
    "uuid": "9eabb6c4-2d95-4d5f-8fdc-33dd048c863e",
    "hitokoto": "断剑重铸之日，骑士归来之时。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "锐雯",
    "creator": "御坂美琴",
    "creator_uid": 9994,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1628141688",
    "length": 14
  },
  {
    "id": 7286,
    "uuid": "37a482ac-c0a1-47a1-9b4e-08a04af0aeac",
    "hitokoto": "春风起，花飘零，梦醒时分，却有几多愁，上心头。",
    "type": "c",
    "from": "东方project",
    "from_who": "太田顺也",
    "creator": "Negative_Number",
    "creator_uid": 8887,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617452135",
    "length": 23
  },
  {
    "id": 7292,
    "uuid": "4f8641d7-7b4b-43e5-bfd3-8958730da786",
    "hitokoto": "谎言不会伤人，真相才是快刀。",
    "type": "c",
    "from": "英雄联盟",
    "from_who": "卡密尔",
    "creator": "楚歌儿",
    "creator_uid": 8920,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617706140",
    "length": 14
  },
  {
    "id": 7308,
    "uuid": "23d0c5f0-9330-4747-9146-919d0ccc0e29",
    "hitokoto": "纵使一次也好，我也想在这个星球上尽情奔跑啊！",
    "type": "c",
    "from": "Eden",
    "from_who": "诗音",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617968167",
    "length": 22
  },
  {
    "id": 7347,
    "uuid": "a403e500-5db6-41d0-86ca-62dc2276fd55",
    "hitokoto": "我们都还没有说再见，所以我不会把它当做离别。",
    "type": "c",
    "from": "原神",
    "from_who": "空/莹",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334426",
    "length": 22
  },
  {
    "id": 7348,
    "uuid": "3d21e92f-4ec4-4b30-b0e7-d809cc5a8e91",
    "hitokoto": "只要不失去你的崇高，整个世界都会为你敞开。",
    "type": "c",
    "from": "原神",
    "from_who": "七天神像",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334541",
    "length": 21
  },
  {
    "id": 7353,
    "uuid": "bedeed3f-f086-4d21-b287-32993b941acd",
    "hitokoto": "欲买桂花同载酒，只可惜故人，何日再见啊。",
    "type": "c",
    "from": "原神",
    "from_who": "钟离",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334344",
    "length": 20
  },
  {
    "id": 7354,
    "uuid": "34b20eb7-ac7b-4b36-bc21-75bd9b78dabb",
    "hitokoto": "但如果不去做的话，梦想永远也不会照进现实。",
    "type": "c",
    "from": "原神",
    "from_who": "小昭（璃月总务司文员）",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334505",
    "length": 21
  },
  {
    "id": 7355,
    "uuid": "06066b83-c2be-4ee7-9256-2bba45554f7a",
    "hitokoto": "有死之隙是因为惧怕死亡，惧怕死亡是因为有挂念的事与人吧。",
    "type": "c",
    "from": "原神",
    "from_who": "流月针武器故事",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334593",
    "length": 28
  },
  {
    "id": 7356,
    "uuid": "bdac91dc-fa1d-4385-a6f5-f6a369e32996",
    "hitokoto": "因为没有人能保证，把真相告诉无知的人，就能让现状变得更好而不是变槽。",
    "type": "c",
    "from": "原神",
    "from_who": "胡桃",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334694",
    "length": 34
  },
  {
    "id": 7357,
    "uuid": "0d06a526-25a9-470d-84e0-d3a8c1c27494",
    "hitokoto": "谁也没有见过风，更别说我和你了。谁也没有见过爱情，直到有束花抛向了自己。",
    "type": "c",
    "from": "原神",
    "from_who": "风华节纪行",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623334902",
    "length": 36
  },
  {
    "id": 7358,
    "uuid": "8ab66f71-6574-423a-a2a2-c3abf05ed5b6",
    "hitokoto": "我们是不会分开的，对吗？我们还要一起走很远很远的路，度过好久好久的时光。",
    "type": "c",
    "from": "原神",
    "from_who": "派蒙",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623335071",
    "length": 36
  },
  {
    "id": 7378,
    "uuid": "e8160b1d-353b-4f18-bf34-0b5b2a65ec99",
    "hitokoto": "现状越是难以置信，我们越是不能停下脚步，对吧？",
    "type": "c",
    "from": "原神",
    "from_who": "派蒙",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625613851",
    "length": 23
  },
  {
    "id": 7391,
    "uuid": "b93baf14-6369-4440-b717-04419450550f",
    "hitokoto": "如果有舍弃地狱的，那也该有救赎地狱的！",
    "type": "c",
    "from": "宇佐见的魔法书",
    "from_who": "黑谷山女",
    "creator": "淮子饺河",
    "creator_uid": 8889,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617460178",
    "length": 19
  },
  {
    "id": 7416,
    "uuid": "7f7d4e57-2190-4842-b19a-faa564787156",
    "hitokoto": "光明，制造瞎子。",
    "type": "c",
    "from": "王者荣耀",
    "from_who": "后羿",
    "creator": "jigeshuohua",
    "creator_uid": 10371,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1631331260",
    "length": 8
  },
  {
    "id": 7425,
    "uuid": "adff5173-5303-49cc-9d91-aac769c209d6",
    "hitokoto": "对于永生之人，最大的敌人，是无聊。",
    "type": "c",
    "from": "东方永夜抄",
    "from_who": "蓬莱山辉夜",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1617969285",
    "length": 17
  },
  {
    "id": 7433,
    "uuid": "34a89860-618f-485a-b287-4f44aa00ed7d",
    "hitokoto": "它以言语中浮现的“罪孽”为食。",
    "type": "c",
    "from": "脑叶公司",
    "from_who": "一罪与百善",
    "creator": "Minecraft.GCB",
    "creator_uid": 9097,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619170457",
    "length": 15
  },
  {
    "id": 7446,
    "uuid": "f8887120-4931-495c-9931-e3dc55da1c0e",
    "hitokoto": "人心中混沌必有，才能孕育出星辰。",
    "type": "c",
    "from": "the final station",
    "from_who": null,
    "creator": "xomk",
    "creator_uid": 9128,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619518474",
    "length": 16
  },
  {
    "id": 7506,
    "uuid": "3cbd309d-e3d0-4898-801b-998a85ed8458",
    "hitokoto": "相信自然，也相信自己。",
    "type": "c",
    "from": "APEX英雄",
    "from_who": "寻血猎犬",
    "creator": "Opynicus",
    "creator_uid": 10302,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630495693",
    "length": 11
  },
  {
    "id": 7508,
    "uuid": "eed62d73-92b6-46b0-9b5d-7fc3215e7a8f",
    "hitokoto": "时间能治愈一切伤痛。",
    "type": "c",
    "from": "泰拉瑞亚",
    "from_who": null,
    "creator": "浅染繁星",
    "creator_uid": 10279,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630330452",
    "length": 10
  }
]